const capList = {
	"6911": "Campione d'Italia",
	"8604": "Ozzano dell'Emilia",
	"10010": "Torre Canavese",
	"10011": "Agliè",
	"10012": "Bollengo",
	"10013": "Borgofranco d'Ivrea",
	"10014": "Caluso",
	"10015": "Ivrea",
	"10016": "Montalto Dora",
	"10017": "Montanaro",
	"10018": "Pavone Canavese",
	"10019": "Strambino",
	"10020": "Verrua Savoia",
	"10022": "Carmagnola",
	"10023": "Chieri",
	"10024": "Moncalieri",
	"10025": "Pino Torinese",
	"10026": "Santena",
	"10028": "Trofarello",
	"10029": "Villastellone",
	"10030": "Vische",
	"10031": "Borgomasino",
	"10032": "Brandizzo",
	"10034": "Chivasso",
	"10035": "Mazzè",
	"10036": "Settimo Torinese",
	"10037": "Torrazza Piemonte",
	"10038": "Verolengo",
	"10040": "Volvera",
	"10041": "Carignano",
	"10042": "Nichelino",
	"10043": "Orbassano",
	"10044": "Pianezza",
	"10045": "Piossasco",
	"10046": "Poirino",
	"10048": "Vinovo",
	"10050": "Villar Focchiardo",
	"10051": "Avigliana",
	"10052": "Bardonecchia",
	"10053": "Bussoleno",
	"10054": "Sauze di Cesana",
	"10055": "Condove",
	"10056": "Oulx",
	"10057": "Sant'Ambrogio di Torino",
	"10058": "Sestriere",
	"10059": "Susa",
	"10060": "Virle Piemonte",
	"10061": "Cavour",
	"10062": "Luserna San Giovanni",
	"10063": "Pomaretto",
	"10064": "Pinerolo",
	"10065": "San Germano Chisone",
	"10066": "Torre Pellice",
	"10067": "Vigone",
	"10068": "Villafranca Piemonte",
	"10069": "Villar Perosa",
	"10070": "Viù",
	"10071": "Borgaro Torinese",
	"10072": "Caselle Torinese",
	"10073": "Ciriè",
	"10074": "Lanzo Torinese",
	"10075": "Mathi",
	"10076": "Nole",
	"10077": "San Maurizio Canavese",
	"10078": "Venaria Reale",
	"10079": "Mappano",
	"10080": "Vistrorio",
	"10081": "Castellamonte",
	"10082": "Cuorgnè",
	"10083": "Favria",
	"10084": "Forno Canavese",
	"10085": "Pont Canavese",
	"10086": "Rivarolo Canavese",
	"10087": "Valperga",
	"10088": "Volpiano",
	"10089": "Valchiusa",
	"10090": "Villarbasse",
	"10091": "Alpignano",
	"10092": "Beinasco",
	"10093": "Collegno",
	"10094": "Valgioie",
	"10095": "Grugliasco",
	"10098": "Rivoli",
	"10099": "San Mauro Torinese",
	"10121": "Torino",
	"11002": "Perloz",
	"11010": "Valsavarenche",
	"11011": "Arvier",
	"11012": "Cogne",
	"11013": "Courmayeur",
	"11014": "Saint-Oyen",
	"11015": "La Salle",
	"11016": "La Thuile",
	"11017": "Morgex",
	"11018": "Villeneuve",
	"11020": "Verrayes",
	"11022": "Brusson",
	"11023": "Saint-Denis",
	"11024": "Pontey",
	"11025": "Gressoney-Saint-Jean",
	"11026": "Pont-Saint-Martin",
	"11027": "Saint-Vincent",
	"11028": "Valtournenche",
	"11029": "Verrès",
	"11100": "Aosta",
	"12010": "Vinadio",
	"12011": "Borgo San Dalmazzo",
	"12012": "Boves",
	"12013": "Chiusa di Pesio",
	"12014": "Demonte",
	"12015": "Limone Piemonte",
	"12016": "Peveragno",
	"12017": "Robilante",
	"12018": "Roccavione",
	"12019": "Vernante",
	"12020": "Vottignasco",
	"12021": "Acceglio",
	"12022": "Busca",
	"12023": "Caraglio",
	"12024": "Costigliole Saluzzo",
	"12025": "Montemale di Cuneo",
	"12026": "Piasco",
	"12027": "Pradleves",
	"12028": "Prazzo",
	"12029": "San Damiano Macra",
	"12030": "Villanova Solaro",
	"12031": "Bagnolo Piemonte",
	"12032": "Barge",
	"12033": "Moretta",
	"12034": "Paesana",
	"12035": "Racconigi",
	"12036": "Revello",
	"12037": "Saluzzo",
	"12038": "Savigliano",
	"12039": "Verzuolo",
	"12040": "Vezza d'Alba",
	"12041": "Bene Vagienna",
	"12042": "Bra",
	"12043": "Canale",
	"12044": "Centallo",
	"12045": "Fossano",
	"12046": "Montà",
	"12047": "Rocca de' Baldi",
	"12048": "Sommariva del Bosco",
	"12049": "Trinità",
	"12050": "Trezzo Tinella",
	"12051": "Alba",
	"12052": "Neive",
	"12053": "Castiglione Tinella",
	"12054": "Cossano Belbo",
	"12055": "Diano d'Alba",
	"12056": "Mango",
	"12058": "Santo Stefano Belbo",
	"12060": "Verduno",
	"12061": "Carrù",
	"12062": "Cherasco",
	"12063": "Dogliani",
	"12064": "La Morra",
	"12065": "Monforte d'Alba",
	"12066": "Monticello d'Alba",
	"12068": "Narzole",
	"12069": "Santa Vittoria d'Alba",
	"12070": "Viola",
	"12071": "Massimino",
	"12072": "Camerana",
	"12073": "Roascio",
	"12074": "Cortemilia",
	"12075": "Garessio",
	"12076": "Lesegno",
	"12077": "Monesiglio",
	"12078": "Ormea",
	"12079": "Saliceto",
	"12080": "Vicoforte",
	"12081": "Beinette",
	"12082": "Frabosa Soprana",
	"12083": "Frabosa Sottana",
	"12084": "Mondovì",
	"12087": "Pamparato",
	"12088": "Roccaforte Mondovì",
	"12089": "Villanova Mondovì",
	"12100": "Cuneo",
	"13010": "Villata",
	"13011": "Borgosesia",
	"13012": "Prarolo",
	"13017": "Quarona",
	"13018": "Valduggia",
	"13019": "Varallo",
	"13020": "Vocca",
	"13021": "Alagna Valsesia",
	"13022": "Boccioleto",
	"13023": "Mollia",
	"13024": "Cellio con Breia",
	"13025": "Fobello",
	"13026": "Carcoforo",
	"13027": "Scopa",
	"13028": "Scopello",
	"13030": "Villarboit",
	"13031": "Arborio",
	"13032": "Asigliano Vercellese",
	"13033": "Costanzana",
	"13034": "Lignana",
	"13035": "Lenta",
	"13036": "Ronsecco",
	"13037": "Serravalle Sesia",
	"13038": "Tricerro",
	"13039": "Trino",
	"13040": "Saluggia",
	"13041": "Bianzè",
	"13043": "Cigliano",
	"13044": "Crescentino",
	"13045": "Lozzolo",
	"13046": "Livorno Ferraris",
	"13047": "San Germano Vercellese",
	"13048": "Santhià",
	"13049": "Tronzano Vercellese",
	"13060": "Roasio",
	"13100": "Vercelli",
	"13811": "Tavigliano",
	"13812": "Piedicavallo",
	"13814": "Pollone",
	"13815": "Rosazza",
	"13816": "Sagliano Micca",
	"13817": "Sordevolo",
	"13818": "Tollegno",
	"13821": "Camandona",
	"13823": "Strona",
	"13824": "Veglio",
	"13831": "Mezzana Mortigliengo",
	"13833": "Portula",
	"13835": "Valdilana",
	"13836": "Cossato",
	"13841": "Bioglio",
	"13843": "Pettinengo",
	"13844": "Ternengo",
	"13845": "Ronco Biellese",
	"13847": "Valle San Nicolao",
	"13848": "Zumaglia",
	"13851": "Castelletto Cervo",
	"13853": "Lessona",
	"13854": "Quaregna Cerreto",
	"13855": "Valdengo",
	"13856": "Vigliano Biellese",
	"13861": "Ailoche",
	"13862": "Brusnengo",
	"13863": "Coggiola",
	"13864": "Crevacuore",
	"13865": "Curino",
	"13866": "Masserano",
	"13867": "Pray",
	"13868": "Villa del Bosco",
	"13871": "Verrone",
	"13872": "Borriana",
	"13873": "Massazza",
	"13874": "Mottalciata",
	"13875": "Ponderano",
	"13876": "Sandigliano",
	"13877": "Villanova Biellese",
	"13878": "Candelo",
	"13881": "Dorzano",
	"13882": "Cerrione",
	"13883": "Roppolo",
	"13884": "Torrazzo",
	"13885": "Salussola",
	"13886": "Viverone",
	"13887": "Zimone",
	"13888": "Zubiena",
	"13891": "Camburzano",
	"13893": "Donato",
	"13894": "Gaglianico",
	"13895": "Muzzano",
	"13896": "Netro",
	"13897": "Occhieppo Inferiore",
	"13898": "Occhieppo Superiore",
	"13899": "Pralungo",
	"13900": "Biella",
	"14010": "Soglio",
	"14011": "Castellero",
	"14012": "Ferrere",
	"14013": "Monale",
	"14014": "Viale",
	"14015": "San Damiano d'Asti",
	"14016": "Tigliole",
	"14017": "Valfenera",
	"14018": "Villafranca d'Asti",
	"14019": "Villanova d'Asti",
	"14020": "Villa San Secondo",
	"14021": "Buttigliera d'Asti",
	"14022": "Castelnuovo Don Bosco",
	"14023": "Tonengo",
	"14024": "Moncucco Torinese",
	"14025": "Montechiaro d'Asti",
	"14026": "Montiglio Monferrato",
	"14030": "Viarigi",
	"14031": "Grana",
	"14032": "Casorzo Monferrato",
	"14033": "Castell'Alfero",
	"14034": "Castello di Annone",
	"14035": "Grazzano Badoglio",
	"14036": "Moncalvo",
	"14037": "Portacomaro",
	"14039": "Tonco",
	"14040": "Vinchio",
	"14041": "Agliano Terme",
	"14042": "Calamandrana",
	"14043": "Castelnuovo Belbo",
	"14044": "Fontanile",
	"14045": "Incisa Scapaccino",
	"14046": "Mombaruzzo",
	"14047": "Mombercelli",
	"14048": "Montegrosso d'Asti",
	"14049": "Nizza Monferrato",
	"14050": "Serole",
	"14051": "Bubbio",
	"14052": "Calosso",
	"14053": "Canelli",
	"14054": "Coazzolo",
	"14055": "Costigliole d'Asti",
	"14057": "Isola d'Asti",
	"14058": "Sessame",
	"14059": "Vesime",
	"14100": "Asti",
	"15010": "Visone",
	"15011": "Acqui Terme",
	"15012": "Bistagno",
	"15013": "Borgoratto Alessandrino",
	"15015": "Malvicino",
	"15016": "Cassine",
	"15017": "Castelnuovo Bormida",
	"15018": "Spigno Monferrato",
	"15019": "Strevi",
	"15020": "Villamiroglio",
	"15021": "Alfiano Natta",
	"15022": "Carentino",
	"15023": "Felizzano",
	"15024": "Masio",
	"15025": "Morano sul Po",
	"15026": "Oviglio",
	"15027": "Pontestura",
	"15028": "Quattordio",
	"15029": "Solero",
	"15030": "Villanova Monferrato",
	"15031": "Balzola",
	"15032": "Borgo San Martino",
	"15033": "Casale Monferrato",
	"15034": "Cella Monte",
	"15035": "Frassinello Monferrato",
	"15036": "Giarole",
	"15037": "Lu e Cuccaro Monferrato",
	"15038": "Ottiglio",
	"15039": "Ozzano Monferrato",
	"15040": "Valmacca",
	"15041": "Altavilla Monferrato",
	"15042": "Bassignana",
	"15043": "Fubine Monferrato",
	"15044": "Quargnento",
	"15045": "Sale",
	"15046": "San Salvatore Monferrato",
	"15048": "Valenza",
	"15049": "Vignale Monferrato",
	"15050": "Volpeglino",
	"15051": "Castellania Coppi",
	"15052": "Casalnoceto",
	"15053": "Castelnuovo Scrivia",
	"15054": "Fabbrica Curone",
	"15055": "Pontecurone",
	"15056": "San Sebastiano Curone",
	"15057": "Tortona",
	"15058": "Viguzzolo",
	"15059": "Volpedo",
	"15060": "Voltaggio",
	"15061": "Arquata Scrivia",
	"15062": "Bosco Marengo",
	"15063": "Cassano Spinola",
	"15064": "Fresonara",
	"15065": "Frugarolo",
	"15066": "Gavi",
	"15067": "Novi Ligure",
	"15068": "Pozzolo Formigaro",
	"15069": "Serravalle Scrivia",
	"15070": "Trisobbio",
	"15071": "Carpeneto",
	"15072": "Casal Cermelli",
	"15073": "Castellazzo Bormida",
	"15074": "Molare",
	"15075": "Mornese",
	"15076": "Ovada",
	"15077": "Predosa",
	"15078": "Rocca Grimalda",
	"15079": "Sezzadio",
	"15121": "Alessandria",
	"16010": "Vobbia",
	"16011": "Arenzano",
	"16012": "Busalla",
	"16013": "Campo Ligure",
	"16014": "Ceranesi",
	"16015": "Casella",
	"16016": "Cogoleto",
	"16017": "Isola del Cantone",
	"16018": "Mignanego",
	"16019": "Ronco Scrivia",
	"16020": "Gorreto",
	"16021": "Bargagli",
	"16022": "Davagna",
	"16023": "Fontanigorda",
	"16024": "Lumarzo",
	"16025": "Rondanina",
	"16026": "Montoggio",
	"16027": "Propata",
	"16028": "Rovegno",
	"16029": "Torriglia",
	"16030": "Tribogna",
	"16031": "Sori",
	"16032": "Camogli",
	"16033": "Lavagna",
	"16034": "Portofino",
	"16035": "Zoagli",
	"16036": "Uscio",
	"16038": "Santa Margherita Ligure",
	"16039": "Sestri Levante",
	"16040": "San Colombano Certenoli",
	"16041": "Borzonasca",
	"16042": "Carasco",
	"16043": "Chiavari",
	"16044": "Cicagna",
	"16045": "Lorsica",
	"16046": "Mezzanego",
	"16047": "Moconesi",
	"16048": "Rezzoaglio",
	"16049": "Santo Stefano d'Aveto",
	"16121": "Genova",
	"17010": "Osiglia",
	"17011": "Albisola Superiore",
	"17012": "Albissola Marina",
	"17013": "Murialdo",
	"17014": "Cairo Montenotte",
	"17015": "Celle Ligure",
	"17017": "Roccavignale",
	"17019": "Varazze",
	"17020": "Tovo San Giacomo",
	"17021": "Alassio",
	"17022": "Borgio Verezzi",
	"17023": "Ceriale",
	"17024": "Orco Feglino",
	"17025": "Loano",
	"17026": "Noli",
	"17027": "Pietra Ligure",
	"17028": "Vezzi Portio",
	"17030": "Onzo",
	"17031": "Albenga",
	"17032": "Vendone",
	"17033": "Garlenda",
	"17034": "Castelvecchio di Rocca Barbena",
	"17035": "Cisano sul Neva",
	"17037": "Ortovero",
	"17038": "Villanova d'Albenga",
	"17039": "Zuccarello",
	"17040": "Mioglia",
	"17041": "Altare",
	"17042": "Pontinvrea",
	"17043": "Plodio",
	"17044": "Stella",
	"17045": "Mallare",
	"17046": "Sassello",
	"17047": "Vado Ligure",
	"17048": "Urbe",
	"17051": "Andora",
	"17052": "Borghetto Santo Spirito",
	"17053": "Laigueglia",
	"17054": "Boissano",
	"17055": "Toirano",
	"17056": "Cengio",
	"17057": "Calizzano",
	"17058": "Piana Crixia",
	"17100": "Savona",
	"18010": "Villa Faraldi",
	"18011": "Castellaro",
	"18012": "Vallebona",
	"18013": "Diano San Pietro",
	"18014": "Ospedaletti",
	"18015": "Riva Ligure",
	"18016": "San Bartolomeo al Mare",
	"18017": "San Lorenzo al Mare",
	"18018": "Taggia",
	"18019": "Vallecrosia",
	"18020": "Vasia",
	"18021": "Borgomaro",
	"18022": "Cesio",
	"18023": "Cosio d'Arroscia",
	"18024": "Pornassio",
	"18025": "Montegrosso Pian Latte",
	"18026": "Vessalico",
	"18027": "Pontedassio",
	"18028": "Montalto Carpasio",
	"18030": "Rocchetta Nervina",
	"18031": "Bajardo",
	"18032": "Perinaldo",
	"18033": "Camporosso",
	"18034": "Ceriana",
	"18035": "Isolabona",
	"18036": "Soldano",
	"18037": "Pigna",
	"18038": "Sanremo",
	"18039": "Ventimiglia",
	"18100": "Imperia",
	"19010": "Maissana",
	"19011": "Bonassola",
	"19012": "Carro",
	"19013": "Deiva Marina",
	"19014": "Framura",
	"19015": "Levanto",
	"19016": "Monterosso al Mare",
	"19017": "Riomaggiore",
	"19018": "Vernazza",
	"19020": "Zignago",
	"19021": "Arcola",
	"19025": "Portovenere",
	"19028": "Varese Ligure",
	"19030": "Lerici",
	"19031": "Ameglia",
	"19033": "Castelnuovo Magra",
	"19034": "Luni",
	"19037": "Santo Stefano di Magra",
	"19038": "Sarzana",
	"19121": "La Spezia",
	"20002": "Ossona",
	"20003": "Casorezzo",
	"20004": "Arluno",
	"20005": "Pogliano Milanese",
	"20006": "Pregnana Milanese",
	"20007": "Cornaredo",
	"20008": "Bareggio",
	"20009": "Vittuone",
	"20010": "Santo Stefano Ticino",
	"20011": "Corbetta",
	"20012": "Cuggiono",
	"20013": "Magenta",
	"20014": "Nerviano",
	"20015": "Parabiago",
	"20016": "Pero",
	"20017": "Rho",
	"20018": "Sedriano",
	"20019": "Settimo Milanese",
	"20020": "Villa Cortese",
	"20021": "Bollate",
	"20022": "Castano Primo",
	"20023": "Cerro Maggiore",
	"20024": "Garbagnate Milanese",
	"20025": "Legnano",
	"20026": "Novate Milanese",
	"20027": "Rescaldina",
	"20028": "San Vittore Olona",
	"20029": "Turbigo",
	"20030": "Senago",
	"20031": "Cesate",
	"20032": "Cormano",
	"20033": "Solaro",
	"20037": "Paderno Dugnano",
	"20040": "Cambiago",
	"20041": "Bussero",
	"20042": "Pessano con Bornago",
	"20043": "Vanzago",
	"20044": "Arese",
	"20045": "Lainate",
	"20046": "Cisliano",
	"20047": "Cusago",
	"20048": "Pantigliate",
	"20049": "Settala",
	"20050": "Liscate",
	"20051": "Cassina de' Pecchi",
	"20052": "Vignate",
	"20053": "Rodano",
	"20054": "Segrate",
	"20055": "Vimodrone",
	"20056": "Trezzo sull'Adda",
	"20057": "Assago",
	"20058": "Zibido San Giacomo",
	"20059": "Casarile",
	"20060": "Truccazzano",
	"20061": "Carugate",
	"20062": "Cassano d'Adda",
	"20063": "Cernusco sul Naviglio",
	"20064": "Gorgonzola",
	"20065": "Inzago",
	"20066": "Melzo",
	"20067": "Tribiano",
	"20068": "Peschiera Borromeo",
	"20069": "Vaprio d'Adda",
	"20070": "Vizzolo Predabissi",
	"20071": "Vermezzo con Zelo",
	"20072": "Pieve Emanuele",
	"20073": "Opera",
	"20074": "Carpiano",
	"20075": "Colturano",
	"20076": "Mediglia",
	"20077": "Melegnano",
	"20078": "San Colombano al Lambro",
	"20079": "Basiglio",
	"20080": "Vernate",
	"20081": "Morimondo",
	"20082": "Noviglio",
	"20083": "Gaggiano",
	"20084": "Lacchiarella",
	"20085": "Locate di Triulzi",
	"20086": "Motta Visconti",
	"20087": "Robecco sul Naviglio",
	"20088": "Rosate",
	"20089": "Rozzano",
	"20090": "Trezzano sul Naviglio",
	"20091": "Bresso",
	"20092": "Cinisello Balsamo",
	"20093": "Cologno Monzese",
	"20094": "Corsico",
	"20095": "Cusano Milanino",
	"20096": "Pioltello",
	"20097": "San Donato Milanese",
	"20098": "San Giuliano Milanese",
	"20099": "Sesto San Giovanni",
	"20141": "Milano",
	"20811": "Cesano Maderno",
	"20812": "Limbiate",
	"20813": "Bovisio-Masciago",
	"20814": "Varedo",
	"20815": "Cogliate",
	"20816": "Ceriano Laghetto",
	"20821": "Meda",
	"20822": "Seveso",
	"20823": "Lentate sul Seveso",
	"20824": "Lazzate",
	"20825": "Barlassina",
	"20826": "Misinto",
	"20831": "Seregno",
	"20832": "Desio",
	"20833": "Giussano",
	"20834": "Nova Milanese",
	"20835": "Muggiò",
	"20836": "Briosco",
	"20837": "Veduggio con Colzano",
	"20838": "Renate",
	"20841": "Carate Brianza",
	"20842": "Besana in Brianza",
	"20843": "Verano Brianza",
	"20844": "Triuggio",
	"20845": "Sovico",
	"20846": "Macherio",
	"20847": "Albiate",
	"20851": "Lissone",
	"20852": "Villasanta",
	"20853": "Biassono",
	"20854": "Vedano al Lambro",
	"20855": "Lesmo",
	"20856": "Correzzana",
	"20857": "Camparada",
	"20861": "Brugherio",
	"20862": "Arcore",
	"20863": "Concorezzo",
	"20864": "Agrate Brianza",
	"20865": "Usmate Velate",
	"20866": "Carnate",
	"20867": "Caponago",
	"20871": "Vimercate",
	"20872": "Cornate d'Adda",
	"20873": "Cavenago di Brianza",
	"20874": "Busnago",
	"20875": "Burago di Molgora",
	"20876": "Ornago",
	"20877": "Roncello",
	"20881": "Bernareggio",
	"20882": "Bellusco",
	"20883": "Mezzago",
	"20884": "Sulbiate",
	"20885": "Ronco Briantino",
	"20886": "Aicurzio",
	"20900": "Monza",
	"21010": "Vizzola Ticino",
	"21011": "Casorate Sempione",
	"21012": "Cassano Magnago",
	"21013": "Gallarate",
	"21014": "Laveno-Mombello",
	"21015": "Lonate Pozzolo",
	"21016": "Luino",
	"21017": "Samarate",
	"21018": "Sesto Calende",
	"21019": "Somma Lombardo",
	"21020": "Varano Borghi",
	"21021": "Angera",
	"21022": "Azzate",
	"21023": "Besozzo",
	"21024": "Biandronno",
	"21025": "Comerio",
	"21026": "Gavirate",
	"21027": "Ispra",
	"21028": "Travedona-Monate",
	"21029": "Vergiate",
	"21030": "Rancio Valcuvia",
	"21031": "Cadegliano-Viconago",
	"21032": "Caravate",
	"21033": "Cittiglio",
	"21034": "Cocquio-Trevisago",
	"21035": "Cunardo",
	"21036": "Gemonio",
	"21037": "Lavena Ponte Tresa",
	"21038": "Sangiano",
	"21039": "Valganna",
	"21040": "Venegono Superiore",
	"21041": "Albizzate",
	"21042": "Caronno Pertusella",
	"21043": "Castiglione Olona",
	"21044": "Cavaria con Premezzo",
	"21045": "Gazzada Schianno",
	"21046": "Malnate",
	"21047": "Saronno",
	"21048": "Solbiate Arno",
	"21049": "Tradate",
	"21050": "Saltrio",
	"21051": "Arcisate",
	"21052": "Busto Arsizio",
	"21053": "Castellanza",
	"21054": "Fagnano Olona",
	"21055": "Gorla Minore",
	"21056": "Induno Olona",
	"21057": "Olgiate Olona",
	"21058": "Solbiate Olona",
	"21059": "Viggiù",
	"21061": "Maccagno con Pino e Veddasca",
	"21062": "Cadrezzate con Osmate",
	"21100": "Varese",
	"22010": "Valsolda",
	"22011": "Griante",
	"22012": "Cernobbio",
	"22013": "Vercana",
	"22014": "Dongo",
	"22015": "Gravedona ed Uniti",
	"22016": "Tremezzina",
	"22017": "Menaggio",
	"22018": "Porlezza",
	"22020": "Zelbio",
	"22021": "Bellagio",
	"22023": "Centro Valle Intelvi",
	"22024": "Alta Valle Intelvi",
	"22025": "Lezzeno",
	"22026": "Maslianico",
	"22027": "Ronago",
	"22028": "Blessagno",
	"22029": "Uggiate-Trevano",
	"22030": "Sormano",
	"22031": "Albavilla",
	"22032": "Albese con Cassano",
	"22033": "Asso",
	"22034": "Brunate",
	"22035": "Canzo",
	"22036": "Erba",
	"22037": "Ponte Lambro",
	"22038": "Tavernerio",
	"22039": "Valbrona",
	"22040": "Monguzzo",
	"22041": "Colverde",
	"22042": "San Fermo della Battaglia",
	"22043": "Solbiate con Cagno",
	"22044": "Inverigo",
	"22045": "Lambrugo",
	"22046": "Merone",
	"22060": "Novedrate",
	"22063": "Cantù",
	"22066": "Mariano Comense",
	"22069": "Rovellasca",
	"22070": "Vertemate con Minoprio",
	"22071": "Cadorago",
	"22072": "Cermenate",
	"22073": "Fino Mornasco",
	"22074": "Lomazzo",
	"22075": "Lurate Caccivio",
	"22076": "Mozzate",
	"22077": "Olgiate Comasco",
	"22078": "Turate",
	"22079": "Villa Guardia",
	"22100": "Como",
	"23009": "Andalo Valtellino",
	"23010": "Val Masino",
	"23011": "Ardenno",
	"23012": "Castione Andevenno",
	"23013": "Cosio Valtellino",
	"23014": "Delebio",
	"23015": "Dubino",
	"23016": "Mantello",
	"23017": "Morbegno",
	"23018": "Talamona",
	"23019": "Traona",
	"23020": "Verceia",
	"23021": "Campodolcino",
	"23022": "Chiavenna",
	"23023": "Chiesa in Valmalenco",
	"23024": "Madesimo",
	"23025": "Novate Mezzola",
	"23026": "Ponte in Valtellina",
	"23027": "Samolaco",
	"23029": "Villa di Chiavenna",
	"23030": "Villa di Tirano",
	"23031": "Aprica",
	"23032": "Bormio",
	"23033": "Grosio",
	"23034": "Grosotto",
	"23035": "Sondalo",
	"23036": "Teglio",
	"23037": "Tirano",
	"23038": "Valdidentro",
	"23041": "Livigno",
	"23100": "Sondrio",
	"23801": "Calolziocorte",
	"23802": "Carenno",
	"23804": "Monte Marenzo",
	"23805": "Erve",
	"23807": "Merate",
	"23808": "Vercurago",
	"23811": "Morterone",
	"23813": "Cortenova",
	"23814": "Cremeno",
	"23815": "Introbio",
	"23816": "Barzio",
	"23817": "Moggio",
	"23818": "Pasturo",
	"23819": "Primaluna",
	"23821": "Abbadia Lariana",
	"23822": "Bellano",
	"23823": "Colico",
	"23824": "Dorio",
	"23825": "Esino Lario",
	"23826": "Mandello del Lario",
	"23827": "Lierna",
	"23828": "Perledo",
	"23829": "Varenna",
	"23831": "Casargo",
	"23832": "Margno",
	"23833": "Pagnona",
	"23834": "Premana",
	"23835": "Sueglio",
	"23836": "Valvarrone",
	"23837": "Taceno",
	"23841": "Annone di Brianza",
	"23842": "Bosisio Parini",
	"23843": "Dolzago",
	"23844": "Sirone",
	"23845": "Costa Masnaga",
	"23846": "Garbagnate Monastero",
	"23847": "Molteno",
	"23848": "Oggiono",
	"23849": "Rogeno",
	"23851": "Galbiate",
	"23852": "Garlate",
	"23854": "Olginate",
	"23855": "Pescate",
	"23857": "Valgreghentino",
	"23861": "Cesana Brianza",
	"23862": "Civate",
	"23864": "Malgrate",
	"23865": "Oliveto Lario",
	"23867": "Suello",
	"23868": "Valmadrera",
	"23870": "Cernusco Lombardone",
	"23871": "Lomagna",
	"23873": "Missaglia",
	"23874": "Montevecchia",
	"23875": "Osnago",
	"23876": "Monticello Brianza",
	"23877": "Paderno d'Adda",
	"23878": "Verderio",
	"23880": "Casatenovo",
	"23881": "Airuno",
	"23883": "Brivio",
	"23884": "Castello di Brianza",
	"23885": "Calco",
	"23886": "Colle Brianza",
	"23887": "Olgiate Molgora",
	"23888": "La Valletta Brianza",
	"23889": "Santa Maria Hoè",
	"23890": "Barzago",
	"23891": "Barzanò",
	"23892": "Bulciago",
	"23893": "Cassago Brianza",
	"23894": "Cremella",
	"23895": "Nibionno",
	"23896": "Sirtori",
	"23897": "Viganò",
	"23898": "Imbersago",
	"23899": "Robbiate",
	"23900": "Lecco",
	"24010": "Vedeseta",
	"24011": "Almè",
	"24012": "Val Brembilla",
	"24013": "Oltre il Colle",
	"24014": "Piazza Brembana",
	"24015": "San Giovanni Bianco",
	"24016": "San Pellegrino Terme",
	"24017": "Serina",
	"24018": "Villa d'Almè",
	"24019": "Zogno",
	"24020": "Vilminore di Scalve",
	"24021": "Albino",
	"24022": "Alzano Lombardo",
	"24023": "Clusone",
	"24024": "Gandino",
	"24025": "Gazzaniga",
	"24026": "Leffe",
	"24027": "Nembro",
	"24028": "Ponte Nossa",
	"24029": "Vertova",
	"24030": "Villa d'Adda",
	"24031": "Almenno San Salvatore",
	"24032": "Torre de' Busi",
	"24033": "Calusco d'Adda",
	"24034": "Cisano Bergamasco",
	"24035": "Curno",
	"24036": "Ponte San Pietro",
	"24037": "Rota d'Imagna",
	"24038": "Sant'Omobono Terme",
	"24039": "Sotto il Monte Giovanni XXIII",
	"24040": "Verdellino",
	"24041": "Brembate",
	"24042": "Capriate San Gervasio",
	"24043": "Caravaggio",
	"24044": "Dalmine",
	"24045": "Fara Gera d'Adda",
	"24046": "Osio Sotto",
	"24047": "Treviglio",
	"24048": "Treviolo",
	"24049": "Verdello",
	"24050": "Zanica",
	"24051": "Antegnate",
	"24052": "Azzano San Paolo",
	"24053": "Brignano Gera d'Adda",
	"24054": "Calcio",
	"24055": "Cologno al Serio",
	"24056": "Fontanella",
	"24057": "Martinengo",
	"24058": "Romano di Lombardia",
	"24059": "Urgnano",
	"24060": "Zandobbio",
	"24061": "Albano Sant'Alessandro",
	"24062": "Costa Volpino",
	"24063": "Castro",
	"24064": "Grumello del Monte",
	"24065": "Lovere",
	"24066": "Pedrengo",
	"24067": "Sarnico",
	"24068": "Seriate",
	"24069": "Trescore Balneario",
	"24070": "Moio de' Calvi",
	"24121": "Bergamo",
	"25010": "Visano",
	"25011": "Calcinato",
	"25012": "Calvisano",
	"25013": "Carpenedolo",
	"25014": "Castenedolo",
	"25015": "Desenzano del Garda",
	"25016": "Ghedi",
	"25017": "Lonato del Garda",
	"25018": "Montichiari",
	"25019": "Sirmione",
	"25020": "Seniga",
	"25021": "Bagnolo Mella",
	"25022": "Borgo San Giacomo",
	"25023": "Gottolengo",
	"25024": "Leno",
	"25025": "Manerbio",
	"25026": "Pontevico",
	"25027": "Quinzano d'Oglio",
	"25028": "Verolanuova",
	"25029": "Verolavecchia",
	"25030": "Villachiara",
	"25031": "Capriolo",
	"25032": "Chiari",
	"25033": "Cologne",
	"25035": "Ospitaletto",
	"25036": "Palazzolo sull'Oglio",
	"25037": "Pontoglio",
	"25038": "Rovato",
	"25039": "Travagliato",
	"25040": "Monticelli Brusati",
	"25042": "Borno",
	"25043": "Breno",
	"25044": "Capo di Ponte",
	"25045": "Castegnato",
	"25046": "Cazzago San Martino",
	"25047": "Darfo Boario Terme",
	"25048": "Sonico",
	"25049": "Iseo",
	"25050": "Zone",
	"25051": "Cedegolo",
	"25052": "Piancogno",
	"25053": "Malegno",
	"25054": "Marone",
	"25055": "Pisogne",
	"25056": "Ponte di Legno",
	"25057": "Sale Marasino",
	"25058": "Sulzano",
	"25059": "Vezza d'Oglio",
	"25060": "Tavernole sul Mella",
	"25061": "Irma",
	"25062": "Concesio",
	"25063": "Gardone Val Trompia",
	"25064": "Gussago",
	"25065": "Lumezzane",
	"25068": "Sarezzo",
	"25069": "Villa Carcina",
	"25070": "Treviso Bresciano",
	"25071": "Agnosine",
	"25072": "Bagolino",
	"25073": "Bovezzo",
	"25074": "Idro",
	"25075": "Nave",
	"25076": "Odolo",
	"25077": "Roè Volciano",
	"25078": "Vestone",
	"25079": "Vobarno",
	"25080": "Valvestino",
	"25081": "Bedizzole",
	"25083": "Gardone Riviera",
	"25084": "Gargnano",
	"25085": "Gavardo",
	"25086": "Rezzato",
	"25087": "Salò",
	"25088": "Toscolano-Maderno",
	"25089": "Villanuova sul Clisi",
	"25121": "Brescia",
	"26010": "Vaiano Cremasco",
	"26011": "Casalbuttano ed Uniti",
	"26012": "Castelleone",
	"26013": "Crema",
	"26014": "Romanengo",
	"26015": "Soresina",
	"26016": "Spino d'Adda",
	"26017": "Trescore Cremasco",
	"26018": "Trigolo",
	"26019": "Vailate",
	"26020": "Spinadesco",
	"26021": "Annicco",
	"26022": "Castelverde",
	"26023": "Grumello Cremonese ed Uniti",
	"26024": "Paderno Ponchielli",
	"26025": "Pandino",
	"26026": "Pizzighettone",
	"26027": "Rivolta d'Adda",
	"26028": "Sesto ed Uniti",
	"26029": "Soncino",
	"26030": "Voltido",
	"26031": "Isola Dovarese",
	"26032": "Ostiano",
	"26033": "Pescarolo ed Uniti",
	"26034": "Piadena Drizzona",
	"26035": "Pieve San Giacomo",
	"26036": "Rivarolo del Re ed Uniti",
	"26037": "San Giovanni in Croce",
	"26038": "Torre de' Picenardi",
	"26039": "Vescovato",
	"26040": "Torricella del Pizzo",
	"26041": "Casalmaggiore",
	"26042": "Cingia de' Botti",
	"26043": "Persico Dosimo",
	"26044": "Grontardo",
	"26045": "Motta Baluffi",
	"26046": "San Daniele Po",
	"26047": "Scandolara Ripa d'Oglio",
	"26048": "Sospiro",
	"26049": "Stagno Lombardo",
	"26100": "Cremona",
	"26811": "Boffalora d'Adda",
	"26812": "Borghetto Lodigiano",
	"26813": "Graffignana",
	"26814": "Livraga",
	"26815": "Massalengo",
	"26816": "Ossago Lodigiano",
	"26817": "San Martino in Strada",
	"26818": "Villanova del Sillaro",
	"26821": "Bertonico",
	"26822": "Brembio",
	"26823": "Castiglione d'Adda",
	"26824": "Cavenago d'Adda",
	"26825": "Mairago",
	"26826": "Secugnago",
	"26827": "Terranova dei Passerini",
	"26828": "Turano Lodigiano",
	"26831": "Casalmaiocco",
	"26832": "Galgagnano",
	"26833": "Merlino",
	"26834": "Corte Palasio",
	"26835": "Crespiatica",
	"26836": "Montanaso Lombardo",
	"26837": "Mulazzano",
	"26838": "Tavazzano con Villavesco",
	"26839": "Zelo Buon Persico",
	"26841": "Casalpusterlengo",
	"26842": "Cornovecchio",
	"26843": "Meleti",
	"26844": "Castelgerundo",
	"26845": "Codogno",
	"26846": "Corno Giovine",
	"26847": "Maleo",
	"26848": "San Fiorano",
	"26849": "Santo Stefano Lodigiano",
	"26851": "Borgo San Giovanni",
	"26852": "Casaletto Lodigiano",
	"26853": "Caselle Lurani",
	"26854": "Pieve Fissiraga",
	"26855": "Lodi Vecchio",
	"26856": "Senna Lodigiana",
	"26857": "Salerano sul Lambro",
	"26858": "Sordio",
	"26859": "Valera Fratta",
	"26861": "Fombio",
	"26862": "Guardamiglio",
	"26863": "Orio Litta",
	"26864": "Ospedaletto Lodigiano",
	"26865": "San Rocco al Porto",
	"26866": "Sant'Angelo Lodigiano",
	"26867": "Somaglia",
	"26900": "Lodi",
	"26943": "Maccastorna",
	"27010": "Zeccone",
	"27011": "Torre de' Negri",
	"27012": "Rognano",
	"27013": "Chignolo Po",
	"27014": "Corteolona e Genzone",
	"27015": "Landriano",
	"27016": "Sant'Alessio con Vialone",
	"27017": "Zerbo",
	"27018": "Vidigulfo",
	"27019": "Villanterio",
	"27020": "Zerbolò",
	"27021": "Bereguardo",
	"27022": "Casorate Primo",
	"27023": "Cassolnovo",
	"27024": "Cilavegna",
	"27025": "Gambolò",
	"27026": "Garlasco",
	"27027": "Gropello Cairoli",
	"27028": "San Martino Siccomario",
	"27029": "Vigevano",
	"27030": "Zinasco",
	"27031": "Candia Lomellina",
	"27032": "Ferrera Erbognone",
	"27034": "Lomello",
	"27035": "Villa Biscossi",
	"27036": "Mortara",
	"27037": "Pieve del Cairo",
	"27038": "Robbio",
	"27039": "Sannazzaro de' Burgondi",
	"27040": "Verrua Po",
	"27041": "Casanova Lonati",
	"27042": "Bressana Bottarone",
	"27043": "San Cipriano Po",
	"27044": "Canneto Pavese",
	"27045": "Casteggio",
	"27046": "Santa Giuletta",
	"27047": "Volpara",
	"27048": "Sommo",
	"27049": "Zenevredo",
	"27050": "Val di Nizza",
	"27051": "Cava Manara",
	"27052": "Rocca Susella",
	"27053": "Verretto",
	"27054": "Montebello della Battaglia",
	"27055": "Rivanazzano Terme",
	"27056": "Cornale e Bastida",
	"27057": "Varzi",
	"27058": "Voghera",
	"27059": "Zavattarello",
	"27061": "Colli Verdi",
	"27100": "Pavia",
	"28010": "Vaprio d'Agogna",
	"28011": "Armeno",
	"28012": "Cressa",
	"28013": "Gattico-Veruno",
	"28014": "Maggiora",
	"28015": "Momo",
	"28016": "Orta San Giulio",
	"28017": "San Maurizio d'Opaglio",
	"28019": "Suno",
	"28020": "Loreglia",
	"28021": "Cannero Riviera",
	"28024": "Gozzano",
	"28028": "Pettenasco",
	"28030": "Toceno",
	"28040": "Varallo Pombia",
	"28041": "Arona",
	"28043": "Bellinzago Novarese",
	"28045": "Invorio",
	"28046": "Meina",
	"28047": "Oleggio",
	"28050": "Pombia",
	"28053": "Castelletto sopra Ticino",
	"28056": "Miazzina",
	"28060": "Vinzaglio",
	"28061": "Biandrate",
	"28062": "Cameri",
	"28064": "Landiona",
	"28065": "Cerano",
	"28066": "Galliate",
	"28068": "Romentino",
	"28069": "Trecate",
	"28070": "Tornaco",
	"28071": "Borgolavezzaro",
	"28072": "Briona",
	"28073": "Fara Novarese",
	"28074": "Ghemme",
	"28075": "Grignasco",
	"28076": "Pogno",
	"28077": "Prato Sesia",
	"28078": "Romagnano Sesia",
	"28079": "Vespolate",
	"28100": "Novara",
	"28801": "Cossogno",
	"28802": "Mergozzo",
	"28803": "Premosello-Chiovenda",
	"28804": "San Bernardino Verbano",
	"28805": "Vogogna",
	"28811": "Arizzano",
	"28812": "Aurano",
	"28813": "Bee",
	"28814": "Cambiasca",
	"28815": "Caprezzo",
	"28818": "Premeno",
	"28819": "Vignone",
	"28822": "Cannobio",
	"28823": "Ghiffa",
	"28824": "Oggebbio",
	"28826": "Trarego Viggiona",
	"28827": "Valle Cannobina",
	"28828": "Gurro",
	"28831": "Baveno",
	"28832": "Belgirate",
	"28833": "Brovello-Carpugnino",
	"28836": "Gignese",
	"28838": "Stresa",
	"28841": "Borgomezzavalle",
	"28842": "Bognanco",
	"28843": "Montescheno",
	"28844": "Villadossola",
	"28845": "Domodossola",
	"28851": "Beura-Cardezza",
	"28852": "Craveggia",
	"28853": "Druogno",
	"28854": "Malesco",
	"28855": "Masera",
	"28856": "Villette",
	"28857": "Santa Maria Maggiore",
	"28859": "Trontano",
	"28861": "Baceno",
	"28862": "Crodo",
	"28863": "Formazza",
	"28864": "Montecrestese",
	"28865": "Crevoladossola",
	"28866": "Premia",
	"28868": "Varzo",
	"28873": "Calasca-Castiglione",
	"28875": "Ceppo Morelli",
	"28876": "Macugnaga",
	"28877": "Ornavasso",
	"28879": "Vanzone con San Carlo",
	"28881": "Casale Corte Cerro",
	"28883": "Gravellona Toce",
	"28884": "Pallanzeno",
	"28885": "Piedimulera",
	"28886": "Pieve Vergonte",
	"28887": "Omegna",
	"28891": "Nonio",
	"28895": "Massiola",
	"28896": "Quarna Sotto",
	"28897": "Valstrona",
	"28898": "Quarna Sopra",
	"28900": "Verbania",
	"29010": "Ziano Piacentino",
	"29011": "Borgonovo Val Tidone",
	"29012": "Caorso",
	"29013": "Carpaneto Piacentino",
	"29014": "Castell'Arquato",
	"29015": "Castel San Giovanni",
	"29016": "Cortemaggiore",
	"29017": "Fiorenzuola d'Arda",
	"29018": "Lugagnano Val d'Arda",
	"29019": "San Giorgio Piacentino",
	"29020": "Zerba",
	"29021": "Bettola",
	"29022": "Bobbio",
	"29023": "Farini",
	"29024": "Ferriere",
	"29025": "Gropparello",
	"29026": "Ottone",
	"29027": "Podenzano",
	"29028": "Ponte dell'Olio",
	"29029": "Rivergaro",
	"29031": "Alta Val Tidone",
	"29121": "Piacenza",
	"30010": "Cona",
	"30014": "Cavarzere",
	"30015": "Chioggia",
	"30016": "Jesolo",
	"30020": "Torre di Mosto",
	"30021": "Caorle",
	"30022": "Ceggia",
	"30023": "Concordia Sagittaria",
	"30024": "Musile di Piave",
	"30025": "Teglio Veneto",
	"30026": "Portogruaro",
	"30027": "San Donà di Piave",
	"30028": "San Michele al Tagliamento",
	"30030": "Vigonovo",
	"30031": "Dolo",
	"30032": "Fiesso d'Artico",
	"30033": "Noale",
	"30034": "Mira",
	"30035": "Mirano",
	"30036": "Santa Maria di Sala",
	"30037": "Scorzè",
	"30038": "Spinea",
	"30039": "Stra",
	"30121": "Venezia",
	"31010": "Orsago",
	"31011": "Asolo",
	"31012": "Cappella Maggiore",
	"31013": "Codognè",
	"31014": "Colle Umberto",
	"31015": "Conegliano",
	"31016": "Cordignano",
	"31017": "Pieve del Grappa",
	"31018": "Gaiarine",
	"31020": "Villorba",
	"31021": "Mogliano Veneto",
	"31022": "Preganziol",
	"31023": "Resana",
	"31024": "Ormelle",
	"31025": "Santa Lucia di Piave",
	"31026": "Sarmede",
	"31027": "Spresiano",
	"31028": "Vazzola",
	"31029": "Vittorio Veneto",
	"31030": "Cison di Valmarino",
	"31031": "Caerano di San Marco",
	"31032": "Casale sul Sile",
	"31033": "Castelfranco Veneto",
	"31034": "Cavaso del Tomba",
	"31035": "Crocetta del Montello",
	"31036": "Istrana",
	"31037": "Loria",
	"31038": "Paese",
	"31039": "Riese Pio X",
	"31040": "Volpago del Montello",
	"31041": "Cornuda",
	"31043": "Fontanelle",
	"31044": "Montebelluna",
	"31045": "Motta di Livenza",
	"31046": "Oderzo",
	"31047": "Ponte di Piave",
	"31048": "San Biagio di Callalta",
	"31049": "Valdobbiadene",
	"31050": "Zenson di Piave",
	"31051": "Follina",
	"31052": "Maserada sul Piave",
	"31053": "Pieve di Soligo",
	"31054": "Possagno",
	"31055": "Quinto di Treviso",
	"31056": "Roncade",
	"31057": "Silea",
	"31058": "Susegana",
	"31059": "Zero Branco",
	"31100": "Treviso",
	"32010": "Zoppè di Cadore",
	"32012": "Val di Zoldo",
	"32013": "Longarone",
	"32014": "Ponte nelle Alpi",
	"32016": "Alpago",
	"32020": "Voltago Agordino",
	"32021": "Agordo",
	"32022": "Alleghe",
	"32026": "Borgo Valbelluna",
	"32027": "Taibon Agordino",
	"32030": "Sovramonte",
	"32031": "Alano di Piave",
	"32032": "Feltre",
	"32033": "Lamon",
	"32034": "Pedavena",
	"32035": "Santa Giustina",
	"32036": "Sedico",
	"32037": "Sospirolo",
	"32038": "Quero Vas",
	"32040": "Vodo Cadore",
	"32041": "Auronzo di Cadore",
	"32042": "Calalzo di Cadore",
	"32043": "Cortina d'Ampezzo",
	"32044": "Pieve di Cadore",
	"32045": "Santo Stefano di Cadore",
	"32046": "San Vito di Cadore",
	"32100": "Belluno",
	"33010": "Venzone",
	"33011": "Artegna",
	"33012": "Sappada",
	"33013": "Gemona del Friuli",
	"33014": "Treppo Ligosullo",
	"33015": "Moggio Udinese",
	"33016": "Pontebba",
	"33017": "Tarcento",
	"33018": "Tarvisio",
	"33019": "Tricesimo",
	"33020": "Zuglio",
	"33021": "Ampezzo",
	"33022": "Arta Terme",
	"33023": "Comeglians",
	"33024": "Forni di Sopra",
	"33025": "Ovaro",
	"33026": "Paluzza",
	"33027": "Paularo",
	"33028": "Tolmezzo",
	"33029": "Villa Santina",
	"33030": "Varmo",
	"33031": "Basiliano",
	"33032": "Bertiolo",
	"33033": "Codroipo",
	"33034": "Fagagna",
	"33035": "Martignacco",
	"33036": "Mereto di Tomba",
	"33037": "Pasian di Prato",
	"33038": "San Daniele del Friuli",
	"33039": "Sedegliano",
	"33040": "Visco",
	"33041": "Aiello del Friuli",
	"33042": "Buttrio",
	"33043": "Cividale del Friuli",
	"33044": "Manzano",
	"33045": "Nimis",
	"33046": "Pulfero",
	"33047": "Remanzacco",
	"33048": "San Giovanni al Natisone",
	"33049": "San Pietro al Natisone",
	"33050": "Trivignano Udinese",
	"33051": "Aquileia",
	"33052": "Cervignano del Friuli",
	"33053": "Latisana",
	"33054": "Lignano Sabbiadoro",
	"33055": "Muzzana del Turgnano",
	"33056": "Palazzolo dello Stella",
	"33057": "Palmanova",
	"33058": "San Giorgio di Nogaro",
	"33059": "Fiumicello Villa Vicentina",
	"33061": "Rivignano Teor",
	"33070": "Polcenigo",
	"33072": "Casarsa della Delizia",
	"33074": "Fontanafredda",
	"33075": "Morsano al Tagliamento",
	"33076": "Pravisdomini",
	"33077": "Sacile",
	"33078": "San Vito al Tagliamento",
	"33079": "Sesto al Reghena",
	"33080": "Zoppola",
	"33081": "Aviano",
	"33082": "Azzano Decimo",
	"33083": "Chions",
	"33084": "Cordenons",
	"33085": "Maniago",
	"33086": "Montereale Valcellina",
	"33087": "Pasiano di Pordenone",
	"33090": "Vito d'Asio",
	"33092": "Meduno",
	"33094": "Pinzano al Tagliamento",
	"33095": "San Giorgio della Richinvelda",
	"33097": "Spilimbergo",
	"33098": "Valvasone Arzene",
	"33099": "Vivaro",
	"33100": "Udine",
	"33170": "Pordenone",
	"34010": "Sgonico-Zgonik",
	"34011": "Duino Aurisina-Devin Nabrežina",
	"34015": "Muggia",
	"34016": "Monrupino-Repentabor",
	"34018": "San Dorligo della Valle-Dolina",
	"34070": "Villesse",
	"34071": "Cormons",
	"34072": "Gradisca d'Isonzo",
	"34073": "Grado",
	"34074": "Monfalcone",
	"34075": "San Canzian d'Isonzo",
	"34076": "Romans d'Isonzo",
	"34077": "Ronchi dei Legionari",
	"34078": "Sagrado",
	"34079": "Staranzano",
	"34136": "Trieste",
	"34170": "Gorizia",
	"35010": "Villanova di Camposampiero",
	"35011": "Campodarsego",
	"35012": "Camposampiero",
	"35013": "Cittadella",
	"35014": "Fontaniva",
	"35015": "Galliera Veneta",
	"35016": "Piazzola sul Brenta",
	"35017": "Piombino Dese",
	"35018": "San Martino di Lupari",
	"35019": "Tombolo",
	"35020": "Tribano",
	"35021": "Agna",
	"35022": "Anguillara Veneta",
	"35023": "Bagnoli di Sopra",
	"35024": "Bovolenta",
	"35025": "Cartura",
	"35026": "Conselve",
	"35027": "Noventa Padovana",
	"35028": "Piove di Sacco",
	"35029": "Pontelongo",
	"35030": "Vo'",
	"35031": "Abano Terme",
	"35032": "Arquà Petrarca",
	"35034": "Lozzo Atestino",
	"35035": "Mestrino",
	"35036": "Montegrotto Terme",
	"35037": "Teolo",
	"35038": "Torreglia",
	"35040": "Villa Estense",
	"35041": "Battaglia Terme",
	"35042": "Este",
	"35043": "Monselice",
	"35044": "Montagnana",
	"35045": "Ospedaletto Euganeo",
	"35046": "Borgo Veneto",
	"35047": "Solesino",
	"35048": "Stanghella",
	"35121": "Padova",
	"36010": "Zanè",
	"36011": "Arsiero",
	"36012": "Asiago",
	"36013": "Piovene Rocchette",
	"36014": "Santorso",
	"36015": "Schio",
	"36016": "Thiene",
	"36020": "Zovencedo",
	"36021": "Villaga",
	"36022": "Cassola",
	"36023": "Longare",
	"36024": "Nanto",
	"36025": "Noventa Vicentina",
	"36026": "Pojana Maggiore",
	"36027": "Rosà",
	"36028": "Rossano Veneto",
	"36029": "Valbrenta",
	"36030": "Zugliano",
	"36031": "Dueville",
	"36032": "Gallio",
	"36033": "Isola Vicentina",
	"36034": "Malo",
	"36035": "Marano Vicentino",
	"36036": "Torrebelvicino",
	"36040": "Valdastico",
	"36042": "Breganze",
	"36043": "Camisano Vicentino",
	"36044": "Val Liona",
	"36045": "Lonigo",
	"36046": "Lusiana Conco",
	"36047": "Montegaldella",
	"36048": "Barbarano Mossano",
	"36050": "Zermeghedo",
	"36051": "Creazzo",
	"36052": "Enego",
	"36053": "Gambellara",
	"36054": "Montebello Vicentino",
	"36055": "Nove",
	"36056": "Tezze sul Brenta",
	"36057": "Arcugnano",
	"36060": "Schiavon",
	"36061": "Bassano del Grappa",
	"36063": "Marostica",
	"36064": "Colceresa",
	"36065": "Mussolente",
	"36066": "Sandrigo",
	"36070": "Trissino",
	"36071": "Arzignano",
	"36072": "Chiampo",
	"36073": "Cornedo Vicentino",
	"36075": "Montecchio Maggiore",
	"36076": "Recoaro Terme",
	"36077": "Altavilla Vicentina",
	"36078": "Valdagno",
	"36100": "Vicenza",
	"37010": "Torri del Benaco",
	"37011": "Bardolino",
	"37014": "Castelnuovo del Garda",
	"37015": "Sant'Ambrogio di Valpolicella",
	"37016": "Garda",
	"37017": "Lazise",
	"37018": "Malcesine",
	"37020": "Sant'Anna d'Alfaedo",
	"37022": "Fumane",
	"37023": "Grezzana",
	"37024": "Negrar di Valpolicella",
	"37026": "Pescantina",
	"37028": "Roverè Veronese",
	"37029": "San Pietro in Cariano",
	"37030": "Vestenanova",
	"37031": "Illasi",
	"37032": "Monteforte d'Alpone",
	"37035": "San Giovanni Ilarione",
	"37036": "San Martino Buon Albergo",
	"37038": "Soave",
	"37039": "Tregnago",
	"37040": "Zimella",
	"37044": "Cologna Veneta",
	"37045": "Legnago",
	"37046": "Minerbe",
	"37049": "Villa Bartolomea",
	"37050": "San Pietro di Morubio",
	"37051": "Bovolone",
	"37052": "Casaleone",
	"37053": "Cerea",
	"37055": "Ronco all'Adige",
	"37056": "Salizzole",
	"37058": "Sanguinetto",
	"37059": "Zevio",
	"37060": "Trevenzuolo",
	"37063": "Isola della Scala",
	"37064": "Povegliano Veronese",
	"37066": "Sommacampagna",
	"37067": "Valeggio sul Mincio",
	"37068": "Vigasio",
	"37069": "Villafranca di Verona",
	"37100": "Verona",
	"38010": "Ton",
	"38011": "Cavareno",
	"38012": "Predaia",
	"38013": "Borgo d'Anaunia",
	"38015": "Lavis",
	"38016": "Mezzocorona",
	"38017": "Mezzolombardo",
	"38018": "Molveno",
	"38019": "Ville d'Anaunia",
	"38020": "Rumo",
	"38022": "Cavizzana",
	"38023": "Cles",
	"38024": "Peio",
	"38025": "Dimaro Folgarida",
	"38026": "Ossana",
	"38027": "Terzolas",
	"38028": "Novella",
	"38029": "Vermiglio",
	"38030": "Ziano di Fiemme",
	"38031": "Campitello di Fassa",
	"38032": "Canazei",
	"38033": "Cavalese",
	"38034": "Cembra Lisignago",
	"38035": "Moena",
	"38036": "San Giovanni di Fassa-Sèn Jan",
	"38037": "Predazzo",
	"38038": "Tesero",
	"38040": "Valfloriana",
	"38041": "Albiano",
	"38042": "Baselga di Pinè",
	"38043": "Bedollo",
	"38045": "Civezzano",
	"38046": "Lavarone",
	"38047": "Segonzano",
	"38048": "Sover",
	"38049": "Altopiano della Vigolana",
	"38050": "Vignola-Falesina",
	"38051": "Ronchi Valsugana",
	"38052": "Caldonazzo",
	"38053": "Castello Tesino",
	"38054": "Primiero San Martino di Castrozza",
	"38055": "Grigno",
	"38056": "Levico Terme",
	"38057": "Pergine Valsugana",
	"38059": "Castel Ivano",
	"38060": "Volano",
	"38061": "Ala",
	"38062": "Arco",
	"38063": "Avio",
	"38064": "Folgaria",
	"38065": "Mori",
	"38066": "Riva del Garda",
	"38067": "Ledro",
	"38068": "Trambileno",
	"38069": "Nago-Torbole",
	"38070": "Stenico",
	"38071": "Bleggio Superiore",
	"38073": "Cavedine",
	"38074": "Dro",
	"38075": "Fiavè",
	"38076": "Madruzzo",
	"38077": "Comano Terme",
	"38079": "Tione di Trento",
	"38080": "Strembo",
	"38082": "Castel Condino",
	"38083": "Borgo Chiese",
	"38085": "Pieve di Bono-Prezzo",
	"38086": "Pinzolo",
	"38087": "Sella Giudicarie",
	"38088": "Spiazzo",
	"38089": "Storo",
	"38091": "Valdaone",
	"38092": "Altavalle",
	"38093": "Contà",
	"38094": "Porte di Rendena",
	"38095": "Tre Ville",
	"38096": "Vallelaghi",
	"38097": "Terre d'Adige",
	"38098": "San Michele all'Adige",
	"38099": "Ville di Fiemme",
	"38121": "Trento",
	"39010": "Verano",
	"39011": "Lana",
	"39012": "Merano",
	"39013": "Moso in Passiria",
	"39014": "Postal",
	"39015": "San Leonardo in Passiria",
	"39016": "Ultimo",
	"39017": "Scena",
	"39018": "Terlano",
	"39019": "Tirolo",
	"39020": "Tubre",
	"39021": "Laces",
	"39022": "Lagundo",
	"39023": "Lasa",
	"39024": "Malles Venosta",
	"39025": "Plaus",
	"39026": "Prato allo Stelvio",
	"39027": "Curon Venosta",
	"39028": "Silandro",
	"39030": "Vandoies",
	"39031": "Brunico",
	"39032": "Campo Tures",
	"39033": "Corvara in Badia",
	"39034": "Dobbiaco",
	"39035": "Valle di Casies",
	"39036": "Badia",
	"39037": "Rodengo",
	"39038": "San Candido",
	"39039": "Villabassa",
	"39040": "Velturno",
	"39041": "Brennero",
	"39042": "Bressanone",
	"39043": "Villandro",
	"39044": "Egna",
	"39045": "Fortezza",
	"39046": "Ortisei",
	"39047": "Santa Cristina Valgardena",
	"39048": "Selva di Val Gardena",
	"39049": "Vipiteno",
	"39050": "Tires",
	"39051": "Vadena",
	"39052": "Caldaro sulla strada del vino",
	"39053": "Cornedo all'Isarco",
	"39054": "Renon",
	"39055": "Laives",
	"39056": "Nova Levante",
	"39057": "Appiano sulla strada del vino",
	"39058": "Sarentino",
	"39100": "Bolzano",
	"40010": "Sala Bolognese",
	"40011": "Anzola dell'Emilia",
	"40012": "Calderara di Reno",
	"40013": "Castel Maggiore",
	"40014": "Crevalcore",
	"40015": "Galliera",
	"40016": "San Giorgio di Piano",
	"40017": "San Giovanni in Persiceto",
	"40018": "San Pietro in Casale",
	"40019": "Sant'Agata Bolognese",
	"40020": "Casalfiumanese",
	"40021": "Borgo Tossignano",
	"40022": "Castel del Rio",
	"40023": "Castel Guelfo di Bologna",
	"40024": "Castel San Pietro Terme",
	"40025": "Fontanelice",
	"40026": "Imola",
	"40027": "Mordano",
	"40030": "Grizzana Morandi",
	"40032": "Camugnano",
	"40033": "Casalecchio di Reno",
	"40034": "Castel d'Aiano",
	"40035": "Castiglione dei Pepoli",
	"40036": "Monzuno",
	"40037": "Sasso Marconi",
	"40038": "Vergato",
	"40041": "Gaggio Montano",
	"40042": "Lizzano in Belvedere",
	"40043": "Marzabotto",
	"40046": "Alto Reno Terme",
	"40048": "San Benedetto Val di Sambro",
	"40050": "Monterenzio",
	"40051": "Malalbergo",
	"40052": "Baricella",
	"40053": "Valsamoggia",
	"40054": "Budrio",
	"40057": "Granarolo dell'Emilia",
	"40059": "Medicina",
	"40060": "Pianoro",
	"40061": "Minerbio",
	"40062": "Molinella",
	"40063": "Monghidoro",
	"40066": "Pieve di Cento",
	"40068": "San Lazzaro di Savena",
	"40069": "Zola Predosa",
	"40131": "Bologna",
	"41011": "Campogalliano",
	"41012": "Carpi",
	"41013": "Castelfranco Emilia",
	"41014": "Castelvetro di Modena",
	"41015": "Nonantola",
	"41016": "Novi di Modena",
	"41017": "Ravarino",
	"41018": "San Cesario sul Panaro",
	"41019": "Soliera",
	"41020": "Riolunato",
	"41021": "Fanano",
	"41022": "Fiumalbo",
	"41023": "Lama Mocogno",
	"41025": "Montecreto",
	"41026": "Pavullo nel Frignano",
	"41027": "Pievepelago",
	"41028": "Serramazzoni",
	"41029": "Sestola",
	"41030": "San Prospero",
	"41031": "Camposanto",
	"41032": "Cavezzo",
	"41033": "Concordia sulla Secchia",
	"41034": "Finale Emilia",
	"41036": "Medolla",
	"41037": "Mirandola",
	"41038": "San Felice sul Panaro",
	"41039": "San Possidonio",
	"41040": "Polinago",
	"41042": "Fiorano Modenese",
	"41043": "Formigine",
	"41045": "Montefiorino",
	"41046": "Palagano",
	"41048": "Prignano sulla Secchia",
	"41049": "Sassuolo",
	"41051": "Castelnuovo Rangone",
	"41052": "Guiglia",
	"41053": "Maranello",
	"41054": "Marano sul Panaro",
	"41055": "Montese",
	"41056": "Savignano sul Panaro",
	"41057": "Spilamberto",
	"41058": "Vignola",
	"41059": "Zocca",
	"41121": "Modena",
	"42010": "Toano",
	"42011": "Bagnolo in Piano",
	"42012": "Campagnola Emilia",
	"42013": "Casalgrande",
	"42014": "Castellarano",
	"42015": "Correggio",
	"42016": "Guastalla",
	"42017": "Novellara",
	"42018": "San Martino in Rio",
	"42019": "Scandiano",
	"42020": "Vetto",
	"42021": "Bibbiano",
	"42022": "Boretto",
	"42023": "Cadelbosco di Sopra",
	"42024": "Castelnovo di Sotto",
	"42025": "Cavriago",
	"42026": "Canossa",
	"42027": "Montecchio Emilia",
	"42028": "Poviglio",
	"42030": "Villa Minozzo",
	"42031": "Baiso",
	"42032": "Ventasso",
	"42033": "Carpineti",
	"42034": "Casina",
	"42035": "Castelnovo ne' Monti",
	"42040": "Campegine",
	"42041": "Brescello",
	"42042": "Fabbrico",
	"42043": "Gattatico",
	"42044": "Gualtieri",
	"42045": "Luzzara",
	"42046": "Reggiolo",
	"42047": "Rolo",
	"42048": "Rubiera",
	"42049": "Sant'Ilario d'Enza",
	"42121": "Reggio nell'Emilia",
	"43010": "Roccabianca",
	"43011": "Busseto",
	"43012": "Fontanellato",
	"43013": "Langhirano",
	"43014": "Medesano",
	"43015": "Noceto",
	"43016": "Polesine Zibello",
	"43017": "San Secondo Parmense",
	"43018": "Sissa Trecasali",
	"43019": "Soragna",
	"43021": "Corniglio",
	"43022": "Montechiarugolo",
	"43024": "Neviano degli Arduini",
	"43025": "Palanzano",
	"43028": "Tizzano Val Parma",
	"43029": "Traversetolo",
	"43030": "Calestano",
	"43032": "Bardi",
	"43035": "Felino",
	"43036": "Fidenza",
	"43037": "Lesignano de' Bagni",
	"43038": "Sala Baganza",
	"43039": "Salsomaggiore Terme",
	"43040": "Varano de' Melegari",
	"43041": "Bedonia",
	"43042": "Berceto",
	"43043": "Borgo Val di Taro",
	"43044": "Collecchio",
	"43045": "Fornovo di Taro",
	"43047": "Pellegrino Parmense",
	"43049": "Varsi",
	"43050": "Valmozzola",
	"43051": "Albareto",
	"43052": "Colorno",
	"43053": "Compiano",
	"43056": "Torrile",
	"43058": "Sorbolo Mezzani",
	"43059": "Tornolo",
	"43121": "Parma",
	"44012": "Bondeno",
	"44015": "Portomaggiore",
	"44019": "Voghiera",
	"44020": "Ostellato",
	"44021": "Codigoro",
	"44022": "Comacchio",
	"44023": "Lagosanto",
	"44026": "Mesola",
	"44027": "Fiscaglia",
	"44028": "Poggio Renatico",
	"44033": "Riva del Po",
	"44034": "Copparo",
	"44037": "Jolanda di Savoia",
	"44039": "Tresignana",
	"44040": "Argenta",
	"44042": "Cento",
	"44047": "Terre del Reno",
	"44049": "Vigarano Mainarda",
	"44121": "Ferrara",
	"45010": "Villadose",
	"45011": "Adria",
	"45012": "Ariano nel Polesine",
	"45014": "Porto Viro",
	"45015": "Corbola",
	"45017": "Loreo",
	"45018": "Porto Tolle",
	"45019": "Taglio di Po",
	"45020": "Villanova del Ghebbo",
	"45021": "Badia Polesine",
	"45022": "Bagnolo di Po",
	"45023": "Costa di Rovigo",
	"45024": "Fiesso Umbertiano",
	"45025": "Fratta Polesine",
	"45026": "Lendinara",
	"45027": "Trecenta",
	"45030": "Villanova Marchesana",
	"45031": "Arquà Polesine",
	"45032": "Bergantino",
	"45033": "Bosaro",
	"45034": "Canaro",
	"45035": "Castelmassa",
	"45036": "Ficarolo",
	"45037": "Melara",
	"45038": "Polesella",
	"45039": "Stienta",
	"45100": "Rovigo",
	"46010": "San Martino dall'Argine",
	"46011": "Acquanegra sul Chiese",
	"46012": "Bozzolo",
	"46013": "Canneto sull'Oglio",
	"46014": "Castellucchio",
	"46017": "Rivarolo Mantovano",
	"46018": "Sabbioneta",
	"46019": "Viadana",
	"46020": "Schivenoglia",
	"46021": "Borgocarbonara",
	"46023": "Gonzaga",
	"46024": "Moglia",
	"46025": "Poggio Rusco",
	"46026": "Quistello",
	"46027": "San Benedetto Po",
	"46028": "Sermide e Felonica",
	"46029": "Suzzara",
	"46030": "Sustinente",
	"46031": "Bagnolo San Vito",
	"46032": "Castelbelforte",
	"46033": "Castel d'Ario",
	"46034": "Borgo Virgilio",
	"46035": "Ostiglia",
	"46036": "Borgo Mantovano",
	"46037": "Roncoferraro",
	"46039": "Villimpenta",
	"46040": "Solferino",
	"46041": "Asola",
	"46042": "Castel Goffredo",
	"46043": "Castiglione delle Stiviere",
	"46044": "Goito",
	"46045": "Marmirolo",
	"46046": "Medole",
	"46047": "Porto Mantovano",
	"46048": "Roverbella",
	"46049": "Volta Mantovana",
	"46051": "San Giorgio Bigarello",
	"46100": "Mantova",
	"47010": "Premilcuore",
	"47011": "Castrocaro Terme e Terra del Sole",
	"47012": "Civitella di Romagna",
	"47013": "Dovadola",
	"47014": "Meldola",
	"47015": "Modigliana",
	"47016": "Predappio",
	"47017": "Rocca San Casciano",
	"47018": "Santa Sofia",
	"47019": "Tredozio",
	"47020": "Roncofreddo",
	"47021": "Bagno di Romagna",
	"47025": "Mercato Saraceno",
	"47027": "Sarsina",
	"47028": "Verghereto",
	"47030": "Sogliano al Rubicone",
	"47032": "Bertinoro",
	"47034": "Forlimpopoli",
	"47035": "Gambettola",
	"47039": "Savignano sul Rubicone",
	"47042": "Cesenatico",
	"47043": "Gatteo",
	"47121": "Forlì",
	"47521": "Cesena",
	"47814": "Bellaria-Igea Marina",
	"47822": "Santarcangelo di Romagna",
	"47824": "Poggio Torriana",
	"47826": "Verucchio",
	"47832": "San Clemente",
	"47833": "Morciano di Romagna",
	"47834": "Montefiore Conca",
	"47835": "Saludecio",
	"47836": "Mondaino",
	"47837": "Montegridolfo",
	"47838": "Riccione",
	"47841": "Cattolica",
	"47842": "San Giovanni in Marignano",
	"47843": "Misano Adriatico",
	"47853": "Coriano",
	"47854": "Montescudo-Monte Colombo",
	"47855": "Gemmano",
	"47861": "Casteldelci",
	"47862": "Maiolo",
	"47863": "Novafeltria",
	"47864": "Pennabilli",
	"47865": "San Leo",
	"47866": "Sant'Agata Feltria",
	"47867": "Talamello",
	"47868": "Montecopiolo",
	"47869": "Sassofeltrio",
	"47921": "Rimini",
	"48010": "Fusignano",
	"48011": "Alfonsine",
	"48012": "Bagnacavallo",
	"48013": "Brisighella",
	"48014": "Castel Bolognese",
	"48015": "Cervia",
	"48017": "Conselice",
	"48018": "Faenza",
	"48020": "Sant'Agata sul Santerno",
	"48022": "Lugo",
	"48024": "Massa Lombarda",
	"48025": "Riolo Terme",
	"48026": "Russi",
	"48027": "Solarolo",
	"48032": "Casola Valsenio",
	"48121": "Ravenna",
	"50012": "Bagno a Ripoli",
	"50013": "Campi Bisenzio",
	"50014": "Fiesole",
	"50018": "Scandicci",
	"50019": "Sesto Fiorentino",
	"50022": "Greve in Chianti",
	"50023": "Impruneta",
	"50025": "Montespertoli",
	"50026": "San Casciano in Val di Pesa",
	"50028": "Barberino Tavarnelle",
	"50031": "Barberino di Mugello",
	"50032": "Borgo San Lorenzo",
	"50033": "Firenzuola",
	"50034": "Marradi",
	"50035": "Palazzuolo sul Senio",
	"50036": "Vaglia",
	"50037": "Scarperia e San Piero",
	"50039": "Vicchio",
	"50041": "Calenzano",
	"50050": "Montaione",
	"50051": "Castelfiorentino",
	"50052": "Certaldo",
	"50053": "Empoli",
	"50054": "Fucecchio",
	"50055": "Lastra a Signa",
	"50056": "Montelupo Fiorentino",
	"50058": "Signa",
	"50059": "Vinci",
	"50060": "San Godenzo",
	"50062": "Dicomano",
	"50063": "Figline e Incisa Valdarno",
	"50066": "Reggello",
	"50067": "Rignano sull'Arno",
	"50068": "Rufina",
	"50100": "Firenze",
	"51010": "Uzzano",
	"51011": "Buggiano",
	"51012": "Pescia",
	"51013": "Chiesina Uzzanese",
	"51015": "Monsummano Terme",
	"51016": "Montecatini-Terme",
	"51018": "Pieve a Nievole",
	"51019": "Ponte Buggianese",
	"51020": "Sambuca Pistoiese",
	"51024": "Abetone Cutigliano",
	"51028": "San Marcello Piteglio",
	"51030": "Serravalle Pistoiese",
	"51031": "Agliana",
	"51035": "Lamporecchio",
	"51036": "Larciano",
	"51037": "Montale",
	"51039": "Quarrata",
	"51100": "Pistoia",
	"52010": "Talla",
	"52011": "Bibbiena",
	"52014": "Poppi",
	"52015": "Pratovecchio Stia",
	"52016": "Castel Focognano",
	"52019": "Laterina Pergine Valdarno",
	"52021": "Bucine",
	"52022": "Cavriglia",
	"52024": "Loro Ciuffenna",
	"52025": "Montevarchi",
	"52026": "Castelfranco Piandiscò",
	"52027": "San Giovanni Valdarno",
	"52028": "Terranuova Bracciolini",
	"52029": "Castiglion Fibocchi",
	"52031": "Anghiari",
	"52033": "Caprese Michelangelo",
	"52035": "Monterchi",
	"52036": "Pieve Santo Stefano",
	"52037": "Sansepolcro",
	"52038": "Sestino",
	"52041": "Civitella in Val di Chiana",
	"52043": "Castiglion Fiorentino",
	"52044": "Cortona",
	"52045": "Foiano della Chiana",
	"52046": "Lucignano",
	"52047": "Marciano della Chiana",
	"52048": "Monte San Savino",
	"52100": "Arezzo",
	"53011": "Castellina in Chianti",
	"53012": "Chiusdino",
	"53013": "Gaiole in Chianti",
	"53014": "Monteroni d'Arbia",
	"53015": "Monticiano",
	"53016": "Murlo",
	"53017": "Radda in Chianti",
	"53018": "Sovicille",
	"53019": "Castelnuovo Berardenga",
	"53020": "Trequanda",
	"53021": "Abbadia San Salvatore",
	"53022": "Buonconvento",
	"53023": "Castiglione d'Orcia",
	"53024": "Montalcino",
	"53025": "Piancastagnaio",
	"53026": "Pienza",
	"53027": "San Quirico d'Orcia",
	"53030": "San Gimignano",
	"53031": "Casole d'Elsa",
	"53032": "Badia Tedalda",
	"53034": "Colle di Val d'Elsa",
	"53035": "Monteriggioni",
	"53036": "Poggibonsi",
	"53040": "San Casciano dei Bagni",
	"53041": "Asciano",
	"53042": "Chianciano Terme",
	"53043": "Chiusi",
	"53045": "Montepulciano",
	"53047": "Sarteano",
	"53048": "Sinalunga",
	"53049": "Torrita di Siena",
	"53100": "Siena",
	"54010": "Podenzana",
	"54011": "Aulla",
	"54012": "Tresana",
	"54013": "Fivizzano",
	"54014": "Casola in Lunigiana",
	"54015": "Comano",
	"54016": "Licciana Nardi",
	"54021": "Bagnone",
	"54023": "Filattiera",
	"54026": "Mulazzo",
	"54027": "Pontremoli",
	"54028": "Villafranca in Lunigiana",
	"54029": "Zeri",
	"54033": "Carrara",
	"54035": "Fosdinovo",
	"54038": "Montignoso",
	"54100": "Massa",
	"55011": "Altopascio",
	"55012": "Capannori",
	"55015": "Montecarlo",
	"55016": "Porcari",
	"55019": "Villa Basilica",
	"55020": "Molazzana",
	"55021": "Fabbriche di Vergemoli",
	"55022": "Bagni di Lucca",
	"55023": "Borgo a Mozzano",
	"55025": "Coreglia Antelminelli",
	"55027": "Gallicano",
	"55030": "Villa Collemandina",
	"55031": "Camporgiano",
	"55032": "Castelnuovo di Garfagnana",
	"55033": "Castiglione di Garfagnana",
	"55034": "Minucciano",
	"55035": "Piazza al Serchio",
	"55036": "Pieve Fosciana",
	"55038": "San Romano in Garfagnana",
	"55039": "Sillano Giuncugnano",
	"55040": "Stazzema",
	"55041": "Camaiore",
	"55042": "Forte dei Marmi",
	"55045": "Pietrasanta",
	"55047": "Seravezza",
	"55049": "Viareggio",
	"55051": "Barga",
	"55054": "Massarosa",
	"55064": "Pescaglia",
	"55100": "Lucca",
	"56010": "Vicopisano",
	"56011": "Calci",
	"56012": "Calcinaia",
	"56017": "San Giuliano Terme",
	"56019": "Vecchiano",
	"56020": "Santa Maria a Monte",
	"56021": "Cascina",
	"56022": "Castelfranco di Sotto",
	"56025": "Pontedera",
	"56028": "San Miniato",
	"56029": "Santa Croce sull'Arno",
	"56030": "Terricciola",
	"56031": "Bientina",
	"56032": "Buti",
	"56033": "Capannoli",
	"56034": "Chianni",
	"56036": "Palaia",
	"56037": "Peccioli",
	"56038": "Ponsacco",
	"56040": "Santa Luce",
	"56041": "Castelnuovo di Val di Cecina",
	"56043": "Fauglia",
	"56045": "Pomarance",
	"56046": "Riparbella",
	"56048": "Volterra",
	"56100": "Pisa",
	"57014": "Collesalvetti",
	"57016": "Rosignano Marittimo",
	"57020": "Sassetta",
	"57021": "Campiglia Marittima",
	"57022": "Castagneto Carducci",
	"57023": "Cecina",
	"57027": "San Vincenzo",
	"57028": "Suvereto",
	"57030": "Marciana",
	"57031": "Capoliveri",
	"57032": "Capraia Isola",
	"57033": "Marciana Marina",
	"57034": "Campo nell'Elba",
	"57036": "Porto Azzurro",
	"57037": "Portoferraio",
	"57038": "Rio",
	"57121": "Livorno",
	"58010": "Sorano",
	"58011": "Capalbio",
	"58014": "Manciano",
	"58017": "Pitigliano",
	"58019": "Monte Argentario",
	"58020": "Scarlino",
	"58022": "Follonica",
	"58023": "Gavorrano",
	"58024": "Massa Marittima",
	"58025": "Monterotondo Marittimo",
	"58026": "Montieri",
	"58031": "Arcidosso",
	"58033": "Castel del Piano",
	"58034": "Castell'Azzara",
	"58036": "Roccastrada",
	"58037": "Santa Fiora",
	"58038": "Seggiano",
	"58042": "Campagnatico",
	"58043": "Castiglione della Pescaia",
	"58044": "Cinigiano",
	"58045": "Civitella Paganico",
	"58051": "Magliano in Toscana",
	"58053": "Roccalbegna",
	"58054": "Scansano",
	"58055": "Semproniano",
	"58100": "Grosseto",
	"59013": "Montemurlo",
	"59015": "Carmignano",
	"59016": "Poggio a Caiano",
	"59021": "Vaiano",
	"59025": "Cantagallo",
	"59026": "Vernio",
	"59100": "Prato",
	"60010": "Ostra Vetere",
	"60011": "Arcevia",
	"60012": "Trecastelli",
	"60013": "Corinaldo",
	"60015": "Falconara Marittima",
	"60018": "Montemarciano",
	"60019": "Senigallia",
	"60020": "Sirolo",
	"60021": "Camerano",
	"60022": "Castelfidardo",
	"60024": "Filottrano",
	"60025": "Loreto",
	"60026": "Numana",
	"60027": "Osimo",
	"60030": "Serra de' Conti",
	"60031": "Castelplanio",
	"60033": "Chiaravalle",
	"60034": "Cupramontana",
	"60035": "Jesi",
	"60036": "Montecarotto",
	"60037": "Monte San Vito",
	"60038": "San Paolo di Jesi",
	"60039": "Staffolo",
	"60040": "Genga",
	"60041": "Sassoferrato",
	"60043": "Cerreto d'Esi",
	"60044": "Fabriano",
	"60048": "Serra San Quirico",
	"60121": "Ancona",
	"61010": "Tavullia",
	"61011": "Gabicce Mare",
	"61012": "Gradara",
	"61013": "Mercatino Conca",
	"61020": "Tavoleto",
	"61021": "Carpegna",
	"61022": "Vallefoglia",
	"61023": "Macerata Feltria",
	"61024": "Mombaroccio",
	"61025": "Montelabbate",
	"61026": "Piandimeleto",
	"61028": "Sassocorvaro Auditore",
	"61029": "Urbino",
	"61030": "Montefelcino",
	"61032": "Fano",
	"61033": "Fermignano",
	"61034": "Fossombrone",
	"61036": "Colli al Metauro",
	"61037": "Mondolfo",
	"61038": "Terre Roveresche",
	"61039": "San Costanzo",
	"61040": "Serra Sant'Abbondio",
	"61041": "Acqualagna",
	"61042": "Apecchio",
	"61043": "Cagli",
	"61044": "Cantiano",
	"61045": "Pergola",
	"61046": "Piobbico",
	"61047": "San Lorenzo in Campo",
	"61048": "Sant'Angelo in Vado",
	"61049": "Urbania",
	"61121": "Pesaro",
	"62010": "Urbisaglia",
	"62011": "Cingoli",
	"62012": "Civitanova Marche",
	"62014": "Corridonia",
	"62015": "Monte San Giusto",
	"62017": "Porto Recanati",
	"62018": "Potenza Picena",
	"62019": "Recanati",
	"62020": "Serrapetrona",
	"62021": "Apiro",
	"62022": "Gagliole",
	"62023": "Esanatoglia",
	"62024": "Matelica",
	"62025": "Pioraco",
	"62026": "San Ginesio",
	"62027": "San Severino Marche",
	"62028": "Sarnano",
	"62029": "Tolentino",
	"62030": "Sefro",
	"62031": "Valfornace",
	"62032": "Camerino",
	"62034": "Muccia",
	"62035": "Fiastra",
	"62036": "Pieve Torina",
	"62038": "Serravalle di Chienti",
	"62039": "Visso",
	"62100": "Macerata",
	"63061": "Massignano",
	"63062": "Montefiore dell'Aso",
	"63063": "Carassai",
	"63064": "Cupra Marittima",
	"63065": "Ripatransone",
	"63066": "Grottammare",
	"63067": "Cossignano",
	"63068": "Montalto delle Marche",
	"63069": "Montedinove",
	"63071": "Rotella",
	"63072": "Castignano",
	"63073": "Offida",
	"63074": "San Benedetto del Tronto",
	"63075": "Acquaviva Picena",
	"63076": "Monteprandone",
	"63077": "Monsampolo del Tronto",
	"63078": "Spinetoli",
	"63079": "Colli del Tronto",
	"63081": "Castorano",
	"63082": "Castel di Lama",
	"63083": "Appignano del Tronto",
	"63084": "Folignano",
	"63085": "Maltignano",
	"63086": "Force",
	"63087": "Comunanza",
	"63088": "Montemonaco",
	"63091": "Venarotta",
	"63092": "Palmiano",
	"63093": "Roccafluvione",
	"63094": "Montegallo",
	"63095": "Acquasanta Terme",
	"63096": "Arquata del Tronto",
	"63100": "Ascoli Piceno",
	"63811": "Sant'Elpidio a Mare",
	"63812": "Montegranaro",
	"63813": "Monte Urano",
	"63814": "Torre San Patrizio",
	"63815": "Monte San Pietrangeli",
	"63816": "Francavilla d'Ete",
	"63821": "Porto Sant'Elpidio",
	"63822": "Porto San Giorgio",
	"63823": "Lapedona",
	"63824": "Altidona",
	"63825": "Monterubbiano",
	"63826": "Moresco",
	"63827": "Pedaso",
	"63828": "Campofilone",
	"63831": "Rapagnano",
	"63832": "Magliano di Tenna",
	"63833": "Montegiorgio",
	"63834": "Massa Fermana",
	"63835": "Montappone",
	"63836": "Monte Vidon Corrado",
	"63837": "Falerone",
	"63838": "Belmonte Piceno",
	"63839": "Servigliano",
	"63841": "Monteleone di Fermo",
	"63842": "Monsampietro Morico",
	"63843": "Montottone",
	"63844": "Grottazzolina",
	"63845": "Ponzano di Fermo",
	"63846": "Monte Giberto",
	"63847": "Monte Vidon Combatte",
	"63848": "Petritoli",
	"63851": "Ortezzano",
	"63852": "Monte Rinaldo",
	"63853": "Montelparo",
	"63854": "Santa Vittoria in Matenano",
	"63855": "Montefalcone Appennino",
	"63856": "Smerillo",
	"63857": "Amandola",
	"63858": "Montefortino",
	"63900": "Fermo",
	"64010": "Valle Castellana",
	"64011": "Alba Adriatica",
	"64012": "Campli",
	"64013": "Corropoli",
	"64014": "Martinsicuro",
	"64015": "Nereto",
	"64016": "Sant'Egidio alla Vibrata",
	"64018": "Tortoreto",
	"64020": "Morro d'Oro",
	"64021": "Giulianova",
	"64023": "Mosciano Sant'Angelo",
	"64024": "Notaresco",
	"64025": "Pineto",
	"64026": "Roseto degli Abruzzi",
	"64027": "Sant'Omero",
	"64028": "Silvi",
	"64030": "Montefino",
	"64031": "Arsita",
	"64032": "Atri",
	"64033": "Bisenti",
	"64034": "Castiglione Messer Raimondo",
	"64035": "Castilenti",
	"64036": "Cellino Attanasio",
	"64037": "Cermignano",
	"64039": "Penna Sant'Andrea",
	"64040": "Cortino",
	"64041": "Castelli",
	"64042": "Colledara",
	"64043": "Crognaleto",
	"64044": "Fano Adriano",
	"64045": "Isola del Gran Sasso d'Italia",
	"64046": "Montorio al Vomano",
	"64047": "Pietracamela",
	"64049": "Tossicia",
	"64100": "Teramo",
	"65010": "Villa Celiera",
	"65011": "Catignano",
	"65012": "Cepagatti",
	"65013": "Città Sant'Angelo",
	"65014": "Loreto Aprutino",
	"65015": "Montesilvano",
	"65017": "Penne",
	"65019": "Pianella",
	"65020": "Turrivalignani",
	"65022": "Bussi sul Tirino",
	"65023": "Caramanico Terme",
	"65024": "Manoppello",
	"65025": "Serramonacesca",
	"65026": "Popoli",
	"65027": "Scafa",
	"65028": "Tocco da Casauria",
	"65029": "Torre de' Passeri",
	"65121": "Pescara",
	"66010": "Villamagna",
	"66011": "Bucchianico",
	"66012": "Casalincontrada",
	"66014": "Crecchio",
	"66015": "Fara San Martino",
	"66016": "Guardiagrele",
	"66017": "Palena",
	"66018": "Taranta Peligna",
	"66019": "Torricella Peligna",
	"66020": "Villalfonsina",
	"66021": "Casalbordino",
	"66022": "Fossacesia",
	"66023": "Francavilla al Mare",
	"66026": "Ortona",
	"66030": "Treglio",
	"66031": "Casalanguida",
	"66032": "Castel Frentano",
	"66033": "Castiglione Messer Marino",
	"66034": "Lanciano",
	"66036": "Orsogna",
	"66037": "Sant'Eusanio del Sangro",
	"66038": "San Vito Chietino",
	"66040": "Rosello",
	"66041": "Atessa",
	"66042": "Bomba",
	"66043": "Casoli",
	"66044": "Archi",
	"66045": "Schiavi di Abruzzo",
	"66046": "Tornareccio",
	"66047": "Villa Santa Maria",
	"66050": "Tufillo",
	"66051": "Cupello",
	"66052": "Gissi",
	"66054": "Vasto",
	"66100": "Chieti",
	"67010": "Barete",
	"67012": "Cagnano Amiterno",
	"67013": "Campotosto",
	"67014": "Capitignano",
	"67015": "Montereale",
	"67017": "Pizzoli",
	"67019": "Scoppito",
	"67020": "Villa Santa Lucia degli Abruzzi",
	"67021": "Barisciano",
	"67022": "Capestrano",
	"67023": "Castel del Monte",
	"67024": "Castelvecchio Subequo",
	"67025": "Ofena",
	"67026": "Poggio Picenze",
	"67027": "Raiano",
	"67028": "San Demetrio ne' Vestini",
	"67029": "Secinaro",
	"67030": "Vittorito",
	"67031": "Castel di Sangro",
	"67032": "Pescasseroli",
	"67033": "Pescocostanzo",
	"67034": "Pettorano sul Gizio",
	"67035": "Pratola Peligna",
	"67036": "Rivisondoli",
	"67037": "Roccaraso",
	"67038": "Scanno",
	"67039": "Sulmona",
	"67040": "Ocre",
	"67041": "Aielli",
	"67043": "Celano",
	"67044": "Cerchio",
	"67045": "Lucoli",
	"67046": "Ovindoli",
	"67047": "Rocca di Cambio",
	"67048": "Rocca di Mezzo",
	"67049": "Tornimparte",
	"67050": "Villavallelonga",
	"67051": "Avezzano",
	"67052": "Balsorano",
	"67053": "Capistrello",
	"67054": "Civitella Roveto",
	"67055": "Gioia dei Marsi",
	"67056": "Luco dei Marsi",
	"67057": "Pescina",
	"67058": "San Benedetto dei Marsi",
	"67059": "Trasacco",
	"67060": "Cappadocia",
	"67061": "Carsoli",
	"67062": "Magliano de' Marsi",
	"67063": "Oricola",
	"67064": "Pereto",
	"67066": "Rocca di Botte",
	"67067": "Sante Marie",
	"67068": "Scurcola Marsicana",
	"67069": "Tagliacozzo",
	"67100": "L'Aquila",
	"70010": "Valenzano",
	"70011": "Alberobello",
	"70013": "Castellana Grotte",
	"70014": "Conversano",
	"70015": "Noci",
	"70016": "Noicattaro",
	"70017": "Putignano",
	"70018": "Rutigliano",
	"70019": "Triggiano",
	"70020": "Toritto",
	"70021": "Acquaviva delle Fonti",
	"70022": "Altamura",
	"70023": "Gioia del Colle",
	"70024": "Gravina in Puglia",
	"70025": "Grumo Appula",
	"70026": "Modugno",
	"70027": "Palo del Colle",
	"70028": "Sannicandro di Bari",
	"70029": "Santeramo in Colle",
	"70032": "Bitonto",
	"70033": "Corato",
	"70037": "Ruvo di Puglia",
	"70038": "Terlizzi",
	"70042": "Mola di Bari",
	"70043": "Monopoli",
	"70044": "Polignano a Mare",
	"70054": "Giovinazzo",
	"70056": "Molfetta",
	"70121": "Bari",
	"71010": "Serracapriola",
	"71011": "Apricena",
	"71012": "Rodi Garganico",
	"71013": "San Giovanni Rotondo",
	"71014": "San Marco in Lamis",
	"71015": "San Nicandro Garganico",
	"71016": "San Severo",
	"71017": "Torremaggiore",
	"71018": "Vico del Gargano",
	"71019": "Vieste",
	"71020": "Rocchetta Sant'Antonio",
	"71021": "Accadia",
	"71022": "Ascoli Satriano",
	"71023": "Bovino",
	"71024": "Candela",
	"71025": "Castelluccio dei Sauri",
	"71026": "Deliceto",
	"71027": "Orsara di Puglia",
	"71028": "Sant'Agata di Puglia",
	"71029": "Troia",
	"71030": "Zapponeta",
	"71031": "Alberona",
	"71032": "Biccari",
	"71033": "Casalnuovo Monterotaro",
	"71034": "Castelnuovo della Daunia",
	"71035": "Celenza Valfortore",
	"71036": "Lucera",
	"71037": "Monte Sant'Angelo",
	"71038": "Pietramontecorvino",
	"71039": "Roseto Valfortore",
	"71040": "Ordona",
	"71041": "Carapelle",
	"71042": "Cerignola",
	"71043": "Manfredonia",
	"71045": "Orta Nova",
	"71047": "Stornara",
	"71048": "Stornarella",
	"71121": "Foggia",
	"72012": "Carovigno",
	"72013": "Ceglie Messapica",
	"72014": "Cisternino",
	"72015": "Fasano",
	"72017": "Ostuni",
	"72018": "San Michele Salentino",
	"72019": "San Vito dei Normanni",
	"72020": "Torchiarolo",
	"72021": "Francavilla Fontana",
	"72022": "Latiano",
	"72023": "Mesagne",
	"72024": "Oria",
	"72025": "San Donaci",
	"72026": "San Pancrazio Salentino",
	"72027": "San Pietro Vernotico",
	"72028": "Torre Santa Susanna",
	"72029": "Villa Castelli",
	"72100": "Brindisi",
	"73010": "Zollino",
	"73011": "Alezio",
	"73012": "Campi Salentina",
	"73013": "Galatina",
	"73014": "Gallipoli",
	"73015": "Salice Salentino",
	"73016": "San Cesario di Lecce",
	"73017": "Sannicola",
	"73018": "Squinzano",
	"73019": "Trepuzzi",
	"73020": "Uggiano la Chiesa",
	"73021": "Calimera",
	"73022": "Corigliano d'Otranto",
	"73023": "Lizzanello",
	"73024": "Maglie",
	"73025": "Martano",
	"73026": "Melendugno",
	"73027": "Minervino di Lecce",
	"73028": "Otranto",
	"73029": "Vernole",
	"73030": "Tiggiano",
	"73031": "Alessano",
	"73032": "Andrano",
	"73033": "Corsano",
	"73034": "Gagliano del Capo",
	"73035": "Miggiano",
	"73036": "Muro Leccese",
	"73037": "Poggiardo",
	"73038": "Spongano",
	"73039": "Tricase",
	"73040": "Supersano",
	"73041": "Carmiano",
	"73042": "Casarano",
	"73043": "Copertino",
	"73044": "Galatone",
	"73045": "Leverano",
	"73046": "Matino",
	"73047": "Monteroni di Lecce",
	"73048": "Nardò",
	"73049": "Ruffano",
	"73050": "Seclì",
	"73051": "Novoli",
	"73052": "Parabita",
	"73053": "Patù",
	"73054": "Presicce-Acquarica",
	"73055": "Racale",
	"73056": "Taurisano",
	"73057": "Taviano",
	"73058": "Tuglie",
	"73059": "Ugento",
	"73100": "Lecce",
	"74010": "Statte",
	"74011": "Castellaneta",
	"74012": "Crispiano",
	"74013": "Ginosa",
	"74014": "Laterza",
	"74015": "Martina Franca",
	"74016": "Massafra",
	"74017": "Mottola",
	"74018": "Palagianello",
	"74019": "Palagiano",
	"74020": "Torricella",
	"74021": "Carosino",
	"74022": "Fragagnano",
	"74023": "Grottaglie",
	"74024": "Manduria",
	"74026": "Pulsano",
	"74027": "San Giorgio Ionico",
	"74028": "Sava",
	"74121": "Taranto",
	"75010": "San Mauro Forte",
	"75011": "Accettura",
	"75012": "Bernalda",
	"75013": "Ferrandina",
	"75014": "Grassano",
	"75016": "Pomarico",
	"75017": "Salandra",
	"75018": "Stigliano",
	"75019": "Tricarico",
	"75020": "Scanzano Jonico",
	"75021": "Colobraro",
	"75022": "Irsina",
	"75023": "Montalbano Jonico",
	"75024": "Montescaglioso",
	"75025": "Policoro",
	"75026": "Rotondella",
	"75027": "San Giorgio Lucano",
	"75028": "Tursi",
	"75029": "Valsinni",
	"75100": "Matera",
	"76011": "Bisceglie",
	"76012": "Canosa di Puglia",
	"76013": "Minervino Murge",
	"76014": "Spinazzola",
	"76015": "Trinitapoli",
	"76016": "Margherita di Savoia",
	"76017": "San Ferdinando di Puglia",
	"76121": "Barletta",
	"76123": "Andria",
	"76125": "Trani",
	"80010": "Villaricca",
	"80011": "Acerra",
	"80012": "Calvizzano",
	"80013": "Casalnuovo di Napoli",
	"80014": "Giugliano in Campania",
	"80016": "Marano di Napoli",
	"80017": "Melito di Napoli",
	"80018": "Mugnano di Napoli",
	"80019": "Qualiano",
	"80020": "Frattaminore",
	"80021": "Afragola",
	"80022": "Arzano",
	"80023": "Caivano",
	"80024": "Cardito",
	"80025": "Casandrino",
	"80026": "Casoria",
	"80027": "Frattamaggiore",
	"80028": "Grumo Nevano",
	"80029": "Sant'Antimo",
	"80030": "Visciano",
	"80031": "Brusciano",
	"80032": "Casamarciano",
	"80033": "Cicciano",
	"80034": "Marigliano",
	"80035": "Nola",
	"80036": "Palma Campania",
	"80038": "Pomigliano d'Arco",
	"80039": "Saviano",
	"80040": "Volla",
	"80041": "Boscoreale",
	"80042": "Boscotrecase",
	"80044": "Ottaviano",
	"80045": "Pompei",
	"80046": "San Giorgio a Cremano",
	"80047": "San Giuseppe Vesuviano",
	"80048": "Sant'Anastasia",
	"80049": "Somma Vesuviana",
	"80050": "Santa Maria la Carità",
	"80051": "Agerola",
	"80053": "Castellammare di Stabia",
	"80054": "Gragnano",
	"80055": "Portici",
	"80056": "Ercolano",
	"80057": "Sant'Antonio Abate",
	"80058": "Torre Annunziata",
	"80059": "Torre del Greco",
	"80061": "Massa Lubrense",
	"80062": "Meta",
	"80063": "Piano di Sorrento",
	"80065": "Sant'Agnello",
	"80067": "Sorrento",
	"80069": "Vico Equense",
	"80070": "Serrara Fontana",
	"80071": "Anacapri",
	"80073": "Capri",
	"80074": "Casamicciola Terme",
	"80075": "Forio",
	"80076": "Lacco Ameno",
	"80077": "Ischia",
	"80078": "Pozzuoli",
	"80079": "Procida",
	"80127": "Napoli",
	"81010": "Valle Agricola",
	"81011": "Alife",
	"81012": "Alvignano",
	"81013": "Piana di Monte Verna",
	"81014": "Capriati a Volturno",
	"81016": "San Potito Sannitico",
	"81017": "Sant'Angelo d'Alife",
	"81020": "Valle di Maddaloni",
	"81021": "Arienzo",
	"81022": "Casagiove",
	"81023": "Cervino",
	"81024": "Maddaloni",
	"81025": "Marcianise",
	"81027": "San Felice a Cancello",
	"81028": "Santa Maria a Vico",
	"81030": "Villa di Briano",
	"81031": "Aversa",
	"81032": "Carinaro",
	"81033": "Casal di Principe",
	"81034": "Mondragone",
	"81035": "Roccamonfina",
	"81036": "San Cipriano d'Aversa",
	"81037": "Sessa Aurunca",
	"81038": "Trentola Ducenta",
	"81039": "Villa Literno",
	"81040": "Rocca d'Evandro",
	"81041": "Bellona",
	"81042": "Giano Vetusto",
	"81043": "Capua",
	"81044": "Tora e Piccilli",
	"81046": "Grazzanise",
	"81047": "Macerata Campania",
	"81049": "San Pietro Infine",
	"81050": "Vitulazio",
	"81051": "Roccaromana",
	"81052": "Pignataro Maggiore",
	"81053": "Riardo",
	"81054": "San Prisco",
	"81055": "Santa Maria Capua Vetere",
	"81056": "Sparanise",
	"81057": "Teano",
	"81058": "Vairano Patenora",
	"81059": "Caianello",
	"81100": "Caserta",
	"82010": "Sant'Angelo a Cupolo",
	"82011": "Paolisi",
	"82012": "Arpaia",
	"82013": "Bonea",
	"82015": "Durazzano",
	"82016": "Montesarchio",
	"82017": "Pannarano",
	"82018": "San Giorgio del Sannio",
	"82019": "Sant'Agata de' Goti",
	"82020": "Sassinoro",
	"82021": "Sant'Arcangelo Trimonte",
	"82022": "Castelfranco in Miscano",
	"82023": "Castelvetere in Val Fortore",
	"82024": "Colle Sannita",
	"82025": "Montefalcone di Val Fortore",
	"82026": "Morcone",
	"82027": "Pontelandolfo",
	"82028": "San Bartolomeo in Galdo",
	"82029": "San Marco dei Cavoti",
	"82030": "Torrecuso",
	"82031": "Amorosi",
	"82032": "Cerreto Sannita",
	"82033": "Cusano Mutri",
	"82034": "San Lupo",
	"82036": "Solopaca",
	"82037": "Telese Terme",
	"82038": "Vitulano",
	"82100": "Benevento",
	"83010": "Tufo",
	"83011": "Altavilla Irpina",
	"83012": "Cervinara",
	"83013": "Mercogliano",
	"83014": "Ospedaletto d'Alpinolo",
	"83015": "Pietrastornina",
	"83016": "Roccabascerana",
	"83017": "Rotondi",
	"83018": "San Martino Valle Caudina",
	"83020": "Taurano",
	"83021": "Avella",
	"83022": "Baiano",
	"83023": "Lauro",
	"83024": "Monteforte Irpino",
	"83025": "Montoro",
	"83027": "Mugnano del Cardinale",
	"83028": "Serino",
	"83029": "Solofra",
	"83030": "Zungoli",
	"83031": "Ariano Irpino",
	"83032": "Bonito",
	"83034": "Casalbore",
	"83035": "Grottaminarda",
	"83036": "Mirabella Eclano",
	"83037": "Montecalvo Irpino",
	"83038": "Montemiletto",
	"83039": "Pratola Serra",
	"83040": "Morra De Sanctis",
	"83041": "Aquilonia",
	"83042": "Atripalda",
	"83043": "Bagnoli Irpino",
	"83044": "Bisaccia",
	"83045": "Calitri",
	"83046": "Lacedonia",
	"83047": "Lioni",
	"83048": "Montella",
	"83049": "Monteverde",
	"83050": "Volturara Irpina",
	"83051": "Nusco",
	"83052": "Paternopoli",
	"83053": "Sant'Andrea di Conza",
	"83054": "Sant'Angelo dei Lombardi",
	"83055": "Sturno",
	"83056": "Teora",
	"83057": "Torella dei Lombardi",
	"83058": "Trevico",
	"83059": "Vallata",
	"83100": "Avellino",
	"84010": "Tramonti",
	"84011": "Amalfi",
	"84012": "Angri",
	"84013": "Cava de' Tirreni",
	"84014": "Nocera Inferiore",
	"84015": "Nocera Superiore",
	"84016": "Pagani",
	"84017": "Positano",
	"84018": "Scafati",
	"84019": "Vietri sul Mare",
	"84020": "Valva",
	"84021": "Buccino",
	"84022": "Campagna",
	"84024": "Contursi Terme",
	"84026": "Postiglione",
	"84027": "Sant'Angelo a Fasanella",
	"84028": "Serre",
	"84029": "Sicignano degli Alburni",
	"84030": "Tortorella",
	"84031": "Auletta",
	"84032": "Buonabitacolo",
	"84033": "Montesano sulla Marcellana",
	"84035": "Polla",
	"84036": "Sala Consilina",
	"84037": "Sant'Arsenio",
	"84038": "Sassano",
	"84039": "Teggiano",
	"84040": "Ispani",
	"84042": "Acerno",
	"84043": "Agropoli",
	"84044": "Albanella",
	"84045": "Altavilla Silentina",
	"84046": "Ascea",
	"84047": "Capaccio Paestum",
	"84048": "Castellabate",
	"84049": "Castel San Lorenzo",
	"84050": "Magliano Vetere",
	"84051": "Centola",
	"84052": "Ceraso",
	"84053": "Cicerale",
	"84055": "Felitto",
	"84056": "Gioi",
	"84057": "Laurino",
	"84060": "Roccagloriosa",
	"84061": "Ogliastro Cilento",
	"84062": "Olevano sul Tusciano",
	"84065": "Piaggine",
	"84066": "Pisciotta",
	"84068": "Pollica",
	"84069": "Roccadaspide",
	"84070": "Valle dell'Angelo",
	"84073": "Sapri",
	"84074": "Sessa Cilento",
	"84075": "Stio",
	"84076": "Torchiara",
	"84077": "Torre Orsaia",
	"84078": "Vallo della Lucania",
	"84079": "Vibonati",
	"84080": "Pellezzano",
	"84081": "Baronissi",
	"84082": "Bracigliano",
	"84083": "Castel San Giorgio",
	"84084": "Fisciano",
	"84085": "Mercato San Severino",
	"84086": "Roccapiemonte",
	"84087": "Sarno",
	"84088": "Siano",
	"84090": "San Mango Piemonte",
	"84091": "Battipaglia",
	"84092": "Bellizzi",
	"84095": "Giffoni Valle Piana",
	"84096": "Montecorvino Rovella",
	"84098": "Pontecagnano Faiano",
	"84099": "San Cipriano Picentino",
	"84121": "Salerno",
	"85010": "Vaglio Basilicata",
	"85011": "Acerenza",
	"85012": "Corleto Perticara",
	"85013": "Genzano di Lucania",
	"85014": "Laurenzana",
	"85015": "Oppido Lucano",
	"85016": "Pietragalla",
	"85017": "Tolve",
	"85018": "Trivigno",
	"85020": "San Fele",
	"85021": "Avigliano",
	"85022": "Barile",
	"85023": "Forenza",
	"85024": "Lavello",
	"85025": "Melfi",
	"85026": "Palazzo San Gervasio",
	"85027": "Rapolla",
	"85028": "Rionero in Vulture",
	"85029": "Venosa",
	"85030": "Terranova di Pollino",
	"85031": "Castelsaraceno",
	"85032": "Chiaromonte",
	"85033": "Episcopia",
	"85034": "Francavilla in Sinni",
	"85035": "Noepoli",
	"85036": "Roccanova",
	"85037": "Sant'Arcangelo",
	"85038": "Senise",
	"85039": "Spinoso",
	"85040": "Viggianello",
	"85042": "Lagonegro",
	"85043": "Latronico",
	"85044": "Lauria",
	"85046": "Maratea",
	"85047": "Moliterno",
	"85048": "Rotonda",
	"85049": "Trecchina",
	"85050": "Tito",
	"85051": "Bella",
	"85052": "Marsico Nuovo",
	"85053": "Montemurro",
	"85054": "Muro Lucano",
	"85055": "Picerno",
	"85056": "Ruoti",
	"85057": "Tramutola",
	"85058": "Vietri di Potenza",
	"85059": "Viggiano",
	"85100": "Potenza",
	"86010": "Tufara",
	"86011": "Baranello",
	"86012": "Cercemaggiore",
	"86013": "Gambatesa",
	"86014": "Guardiaregia",
	"86015": "Jelsi",
	"86016": "Riccia",
	"86017": "Sepino",
	"86018": "Toro",
	"86019": "Vinchiaturo",
	"86020": "Spinete",
	"86021": "Bojano",
	"86022": "Limosano",
	"86023": "Montagano",
	"86024": "Petrella Tifernina",
	"86025": "Ripalimosani",
	"86026": "Salcito",
	"86027": "San Massimo",
	"86028": "Torella del Sannio",
	"86029": "Trivento",
	"86030": "Tavenna",
	"86031": "Castelmauro",
	"86032": "Montecilfone",
	"86033": "Montefalcone nel Sannio",
	"86034": "Guglionesi",
	"86035": "Larino",
	"86036": "Montenero di Bisaccia",
	"86037": "Palata",
	"86038": "Petacciato",
	"86039": "Termoli",
	"86040": "San Giuliano di Puglia",
	"86041": "Bonefro",
	"86042": "Campomarino",
	"86043": "Casacalenda",
	"86044": "Colletorto",
	"86045": "Portocannone",
	"86046": "San Martino in Pensilis",
	"86047": "Santa Croce di Magliano",
	"86048": "Sant'Elia a Pianisi",
	"86049": "Ururi",
	"86070": "Scapoli",
	"86071": "Pizzone",
	"86072": "Cerro al Volturno",
	"86073": "Colli a Volturno",
	"86074": "Filignano",
	"86075": "Monteroduni",
	"86077": "Pozzilli",
	"86078": "Sesto Campano",
	"86079": "Venafro",
	"86080": "Sant'Angelo del Pesco",
	"86081": "Agnone",
	"86082": "Capracotta",
	"86083": "Carovilli",
	"86084": "Forlì del Sannio",
	"86085": "Pietrabbondante",
	"86086": "Poggio Sannita",
	"86087": "Rionero Sannitico",
	"86088": "San Pietro Avellana",
	"86089": "Vastogirardi",
	"86090": "Santa Maria del Molise",
	"86091": "Bagnoli del Trigno",
	"86092": "Roccamandolfi",
	"86093": "Carpinone",
	"86094": "Civitanova del Sannio",
	"86095": "Frosolone",
	"86096": "Macchiagodena",
	"86097": "Sessano del Molise",
	"86099": "Sant'Elena Sannita",
	"86100": "Campobasso",
	"86170": "Isernia",
	"87010": "Torano Castello",
	"87011": "Cassano all'Ionio",
	"87012": "Castrovillari",
	"87013": "Fagnano Castello",
	"87014": "Laino Borgo",
	"87015": "Laino Castello",
	"87016": "Morano Calabro",
	"87017": "Roggiano Gravina",
	"87018": "San Marco Argentano",
	"87019": "Spezzano Albanese",
	"87020": "Verbicaro",
	"87021": "Belvedere Marittimo",
	"87022": "Cetraro",
	"87023": "Diamante",
	"87024": "Fuscaldo",
	"87026": "Mormanno",
	"87027": "Paola",
	"87028": "Praia a Mare",
	"87029": "Scalea",
	"87030": "Serra d'Aiello",
	"87031": "Aiello Calabro",
	"87032": "Amantea",
	"87033": "Belmonte Calabro",
	"87034": "Grimaldi",
	"87035": "Lago",
	"87036": "Rende",
	"87037": "San Fili",
	"87038": "San Lucido",
	"87040": "Zumpano",
	"87041": "Acri",
	"87042": "Altomonte",
	"87043": "Bisignano",
	"87044": "Cerisano",
	"87045": "Dipignano",
	"87046": "Montalto Uffugo",
	"87047": "San Pietro in Guarano",
	"87048": "Santa Sofia d'Epiro",
	"87050": "Rovito",
	"87051": "Aprigliano",
	"87053": "Celico",
	"87054": "Rogliano",
	"87055": "San Giovanni in Fiore",
	"87056": "Santo Stefano di Rogliano",
	"87057": "Scigliano",
	"87058": "Spezzano della Sila",
	"87059": "Casali del Manco",
	"87060": "Vaccarizzo Albanese",
	"87061": "Campana",
	"87063": "Cariati",
	"87064": "Corigliano-Rossano",
	"87066": "Longobucco",
	"87069": "San Demetrio Corone",
	"87070": "San Lorenzo Bellizzi",
	"87071": "Amendolara",
	"87072": "Francavilla Marittima",
	"87073": "Oriolo",
	"87074": "Rocca Imperiale",
	"87075": "Trebisacce",
	"87076": "Villapiana",
	"87100": "Cosenza",
	"88020": "Nardodipace",
	"88021": "San Floro",
	"88022": "Curinga",
	"88024": "Girifalco",
	"88025": "San Pietro a Maida",
	"88040": "Settingiano",
	"88041": "Decollatura",
	"88042": "Falerna",
	"88044": "Marcellinara",
	"88045": "Gimigliano",
	"88046": "Lamezia Terme",
	"88047": "Nocera Terinese",
	"88049": "Soveria Mannelli",
	"88050": "Zagarise",
	"88051": "Cropani",
	"88054": "Sersale",
	"88055": "Taverna",
	"88056": "Tiriolo",
	"88060": "Torre di Ruggiero",
	"88061": "Badolato",
	"88062": "Cardinale",
	"88064": "Chiaravalle Centrale",
	"88065": "Guardavalle",
	"88067": "San Vito sullo Ionio",
	"88068": "Soverato",
	"88069": "Stalettì",
	"88070": "Botricello",
	"88100": "Catanzaro",
	"88811": "Cirò Marina",
	"88812": "Crucoli",
	"88813": "Cirò",
	"88814": "Melissa",
	"88816": "Strongoli",
	"88817": "San Nicola dell'Alto",
	"88818": "Pallagorio",
	"88819": "Verzino",
	"88821": "Rocca di Neto",
	"88822": "Casabona",
	"88823": "Umbriatico",
	"88824": "Belvedere di Spinello",
	"88825": "Savelli",
	"88831": "Scandale",
	"88832": "Santa Severina",
	"88833": "Cerenzia",
	"88834": "Castelsilano",
	"88835": "Roccabernarda",
	"88836": "Cotronei",
	"88837": "Petilia Policastro",
	"88838": "Mesoraca",
	"88841": "Isola di Capo Rizzuto",
	"88842": "Cutro",
	"88900": "Crotone",
	"89010": "Varapodio",
	"89011": "Bagnara Calabra",
	"89012": "Delianuova",
	"89013": "Gioia Tauro",
	"89014": "Oppido Mamertina",
	"89015": "Palmi",
	"89016": "Rizziconi",
	"89017": "San Giorgio Morgeto",
	"89018": "Villa San Giovanni",
	"89020": "Sinopoli",
	"89021": "Cinquefrondi",
	"89022": "Cittanova",
	"89023": "Laureana di Borrello",
	"89024": "Polistena",
	"89025": "Rosarno",
	"89026": "San Ferdinando",
	"89027": "Sant'Eufemia d'Aspromonte",
	"89028": "Seminara",
	"89029": "Taurianova",
	"89030": "Staiti",
	"89031": "Ardore",
	"89032": "Bianco",
	"89033": "Bova",
	"89034": "Bovalino",
	"89035": "Bova Marina",
	"89036": "Brancaleone",
	"89039": "Platì",
	"89040": "Stignano",
	"89041": "Caulonia",
	"89042": "Gioiosa Ionica",
	"89043": "Grotteria",
	"89044": "Locri",
	"89045": "Mammola",
	"89046": "Marina di Gioiosa Ionica",
	"89047": "Roccella Ionica",
	"89048": "Siderno",
	"89049": "Stilo",
	"89050": "Sant'Alessio in Aspromonte",
	"89052": "Campo Calabro",
	"89054": "Galatro",
	"89056": "Santa Cristina d'Aspromonte",
	"89057": "Santo Stefano in Aspromonte",
	"89058": "Scilla",
	"89060": "Roghudi",
	"89063": "Melito di Porto Salvo",
	"89064": "Montebello Jonico",
	"89065": "Motta San Giovanni",
	"89069": "San Lorenzo",
	"89121": "Reggio di Calabria",
	"89812": "Pizzo",
	"89813": "Polia",
	"89814": "Filadelfia",
	"89815": "Francavilla Angitola",
	"89816": "Cessaniti",
	"89817": "Briatico",
	"89818": "Capistrano",
	"89819": "Monterosso Calabro",
	"89821": "Vallelonga",
	"89822": "Spadola",
	"89823": "Mongiana",
	"89831": "Soriano Calabro",
	"89832": "Dasà",
	"89833": "Dinami",
	"89834": "Vazzano",
	"89841": "Rombiolo",
	"89842": "San Calogero",
	"89843": "Stefanaconi",
	"89844": "Nicotera",
	"89851": "San Costantino Calabro",
	"89852": "Mileto",
	"89853": "San Gregorio d'Ippona",
	"89861": "Tropea",
	"89862": "Drapia",
	"89863": "Joppolo",
	"89864": "Spilinga",
	"89865": "Ricadi",
	"89867": "Zungri",
	"89868": "Zambrone",
	"89900": "Vibo Valentia",
	"90010": "San Mauro Castelverde",
	"90011": "Bagheria",
	"90012": "Caccamo",
	"90013": "Castelbuono",
	"90014": "Casteldaccia",
	"90015": "Cefalù",
	"90016": "Collesano",
	"90017": "Santa Flavia",
	"90018": "Termini Imerese",
	"90019": "Trabia",
	"90020": "Vicari",
	"90021": "Alia",
	"90022": "Caltavuturo",
	"90023": "Ciminna",
	"90024": "Gangi",
	"90025": "Lercara Friddi",
	"90026": "Petralia Soprana",
	"90027": "Petralia Sottana",
	"90028": "Polizzi Generosa",
	"90029": "Valledolmo",
	"90030": "Villafrati",
	"90031": "Belmonte Mezzagno",
	"90032": "Bisacquino",
	"90033": "Chiusa Sclafani",
	"90034": "Corleone",
	"90035": "Marineo",
	"90036": "Misilmeri",
	"90037": "Piana degli Albanesi",
	"90038": "Prizzi",
	"90039": "Villabate",
	"90040": "Trappeto",
	"90041": "Balestrate",
	"90042": "Borgetto",
	"90043": "Camporeale",
	"90044": "Carini",
	"90045": "Cinisi",
	"90046": "Monreale",
	"90047": "Partinico",
	"90048": "San Giuseppe Jato",
	"90049": "Terrasini",
	"90051": "Ustica",
	"90144": "Palermo",
	"91010": "Vita",
	"91011": "Alcamo",
	"91012": "Buseto Palizzolo",
	"91013": "Calatafimi-Segesta",
	"91014": "Castellammare del Golfo",
	"91015": "Custonaci",
	"91016": "Erice",
	"91017": "Pantelleria",
	"91018": "Salemi",
	"91019": "Valderice",
	"91020": "Salaparuta",
	"91021": "Campobello di Mazara",
	"91022": "Castelvetrano",
	"91023": "Favignana",
	"91024": "Gibellina",
	"91025": "Marsala",
	"91027": "Paceco",
	"91028": "Partanna",
	"91029": "Santa Ninfa",
	"91031": "Misiliscemi",
	"91100": "Trapani",
	"92010": "Siculiana",
	"92011": "Cattolica Eraclea",
	"92012": "Cianciana",
	"92013": "Menfi",
	"92014": "Porto Empedocle",
	"92015": "Raffadali",
	"92016": "Ribera",
	"92017": "Sambuca di Sicilia",
	"92018": "Santa Margherita di Belice",
	"92019": "Sciacca",
	"92020": "Villafranca Sicula",
	"92021": "Aragona",
	"92022": "Cammarata",
	"92023": "Campobello di Licata",
	"92024": "Canicattì",
	"92025": "Casteltermini",
	"92026": "Favara",
	"92027": "Licata",
	"92028": "Naro",
	"92029": "Ravanusa",
	"92100": "Agrigento",
	"93010": "Villalba",
	"93011": "Butera",
	"93012": "Gela",
	"93013": "Mazzarino",
	"93014": "Mussomeli",
	"93015": "Niscemi",
	"93016": "Riesi",
	"93017": "San Cataldo",
	"93018": "Santa Caterina Villarmosa",
	"93019": "Sommatino",
	"93100": "Caltanissetta",
	"94010": "Villarosa",
	"94011": "Agira",
	"94012": "Barrafranca",
	"94013": "Leonforte",
	"94014": "Nicosia",
	"94015": "Piazza Armerina",
	"94016": "Pietraperzia",
	"94017": "Regalbuto",
	"94018": "Troina",
	"94019": "Valguarnera Caropepe",
	"94100": "Enna",
	"95010": "Santa Venerina",
	"95011": "Calatabiano",
	"95012": "Castiglione di Sicilia",
	"95013": "Fiumefreddo di Sicilia",
	"95014": "Giarre",
	"95015": "Linguaglossa",
	"95016": "Mascali",
	"95018": "Riposto",
	"95019": "Zafferana Etnea",
	"95020": "Aci Bonaccorsi",
	"95021": "Aci Castello",
	"95022": "Aci Catena",
	"95024": "Acireale",
	"95025": "Aci Sant'Antonio",
	"95027": "San Gregorio di Catania",
	"95028": "Valverde",
	"95029": "Viagrande",
	"95030": "Tremestieri Etneo",
	"95031": "Adrano",
	"95032": "Belpasso",
	"95033": "Biancavilla",
	"95034": "Bronte",
	"95035": "Maletto",
	"95036": "Randazzo",
	"95037": "San Giovanni la Punta",
	"95038": "Santa Maria di Licodia",
	"95039": "Trecastagni",
	"95040": "San Michele di Ganzaria",
	"95041": "Caltagirone",
	"95042": "Grammichele",
	"95043": "Militello in Val di Catania",
	"95044": "Mineo",
	"95045": "Misterbianco",
	"95046": "Palagonia",
	"95047": "Paternò",
	"95048": "Scordia",
	"95049": "Vizzini",
	"95121": "Catania",
	"96010": "Sortino",
	"96011": "Augusta",
	"96012": "Avola",
	"96013": "Carlentini",
	"96014": "Floridia",
	"96015": "Francofonte",
	"96016": "Lentini",
	"96017": "Noto",
	"96018": "Pachino",
	"96019": "Rosolini",
	"96100": "Siracusa",
	"97010": "Monterosso Almo",
	"97011": "Acate",
	"97012": "Chiaramonte Gulfi",
	"97013": "Comiso",
	"97014": "Ispica",
	"97015": "Modica",
	"97016": "Pozzallo",
	"97017": "Santa Croce Camerina",
	"97018": "Scicli",
	"97019": "Vittoria",
	"97100": "Ragusa",
	"98020": "Pagliara",
	"98021": "Alì Terme",
	"98022": "Fiumedinisi",
	"98023": "Furci Siculo",
	"98025": "Itala",
	"98026": "Nizza di Sicilia",
	"98027": "Roccalumera",
	"98028": "Santa Teresa di Riva",
	"98029": "Scaletta Zanclea",
	"98030": "Santa Domenica Vittoria",
	"98031": "Capizzi",
	"98032": "Casalvecchio Siculo",
	"98033": "Cesarò",
	"98034": "Francavilla di Sicilia",
	"98035": "Giardini-Naxos",
	"98036": "Graniti",
	"98037": "Letojanni",
	"98038": "Savoca",
	"98039": "Taormina",
	"98040": "Venetico",
	"98041": "Monforte San Giorgio",
	"98042": "Pace del Mela",
	"98043": "Rometta",
	"98045": "San Pier Niceto",
	"98046": "Santa Lucia del Mela",
	"98047": "Saponara",
	"98048": "Spadafora",
	"98049": "Villafranca Tirrena",
	"98050": "Terme Vigliatore",
	"98051": "Barcellona Pozzo di Gotto",
	"98053": "Castroreale",
	"98054": "Furnari",
	"98056": "Mazzarrà Sant'Andrea",
	"98057": "Milazzo",
	"98058": "Novara di Sicilia",
	"98059": "Rodì Milici",
	"98060": "Ucria",
	"98061": "Brolo",
	"98062": "Ficarra",
	"98063": "Gioiosa Marea",
	"98064": "Librizzi",
	"98065": "Montalbano Elicona",
	"98066": "Patti",
	"98067": "Raccuja",
	"98068": "San Piero Patti",
	"98069": "Sinagra",
	"98070": "Torrenova",
	"98072": "Caronia",
	"98073": "Mistretta",
	"98074": "Naso",
	"98075": "San Fratello",
	"98076": "Sant'Agata di Militello",
	"98077": "Santo Stefano di Camastra",
	"98078": "Tortorici",
	"98079": "Tusa",
	"98121": "Messina",
	"09071": "Abbasanta",
	"02011": "Accumoli",
	"03040": "Viticuso",
	"01021": "Acquapendente",
	"05021": "Acquasparta",
	"03010": "Vico nel Lazio",
	"00021": "Affile",
	"07020": "Telti",
	"00020": "Vivaro Romano",
	"09070": "Zerfaliu",
	"03011": "Alatri",
	"09090": "Villa Verde",
	"00041": "Albano Laziale",
	"09091": "Ales",
	"07041": "Alghero",
	"09080": "Villaurbana",
	"05011": "Allerona",
	"00051": "Allumiere",
	"05020": "Montecchio",
	"03041": "Alvito",
	"03021": "Amaseno",
	"02012": "Amatrice",
	"05022": "Amelia",
	"03012": "Anagni",
	"07010": "Tula",
	"00061": "Anguillara Sabazia",
	"00022": "Anticoli Corrado",
	"02013": "Antrodoco",
	"00042": "Anzio",
	"04011": "Aprilia",
	"03031": "Aquino",
	"09092": "Arborea",
	"09031": "Arbus",
	"03032": "Arce",
	"09081": "Ardauli",
	"00040": "Rocca Priora",
	"08031": "Aritzo",
	"01010": "Villa San Giovanni in Tuscia",
	"09040": "Villasalto",
	"03020": "Villa Santo Stefano",
	"03033": "Arpino",
	"05031": "Arrone",
	"00023": "Arsoli",
	"00031": "Artena",
	"07021": "Arzachena",
	"08040": "Ussassai",
	"02020": "Varco Sabino",
	"09032": "Assemini",
	"06081": "Assisi",
	"03042": "Atina",
	"05012": "Attigliano",
	"08030": "Teti",
	"07030": "Viddalba",
	"01022": "Bagnoregio",
	"07040": "Uri",
	"08042": "Bari Sardo",
	"09021": "Barumini",
	"05023": "Baschi",
	"01030": "Vitorchiano",
	"04010": "Sonnino",
	"06083": "Bastia Umbra",
	"00030": "San Vito Romano",
	"07022": "Berchidda",
	"06084": "Bettona",
	"06031": "Bevagna",
	"08010": "Noragugume",
	"08021": "Bitti",
	"08011": "Bolotana",
	"01023": "Bolsena",
	"01020": "San Lorenzo Nuovo",
	"07043": "Bonnanaro",
	"07011": "Bono",
	"07012": "Bonorva",
	"02010": "Rivodutri",
	"02021": "Borgorose",
	"08016": "Borore",
	"08012": "Bortigali",
	"09089": "Bosa",
	"03022": "Boville Ernica",
	"00062": "Bracciano",
	"03030": "Villa Santa Lucia",
	"07051": "Budoni",
	"09010": "Villaspeciosa",
	"09082": "Busachi",
	"09072": "Cabras",
	"09134": "Cagliari",
	"07023": "Calangianus",
	"09011": "Calasetta",
	"05032": "Calvi dell'Umbria",
	"00063": "Campagnano di Roma",
	"06042": "Campello sul Clitunno",
	"04020": "Ventotene",
	"00060": "Torrita Tiberina",
	"01011": "Canino",
	"06033": "Cannara",
	"02014": "Cantalice",
	"02040": "Vacone",
	"09012": "Capoterra",
	"01012": "Capranica",
	"01032": "Caprarola",
	"09013": "Carbonia",
	"09014": "Carloforte",
	"00032": "Carpineto Romano",
	"03034": "Casalvieri",
	"00010": "Tivoli",
	"02030": "Torricella in Sabina",
	"06043": "Cascia",
	"02041": "Casperia",
	"03043": "Cassino",
	"00073": "Castel Gandolfo",
	"05013": "Castel Giorgio",
	"00024": "Castel Madama",
	"06044": "Castel Ritaldi",
	"05014": "Castel Viscardo",
	"04021": "Castelforte",
	"02031": "Castelnuovo di Farfa",
	"07031": "Castelsardo",
	"06061": "Castiglione del Lago",
	"01024": "Castiglione in Teverina",
	"00033": "Cave",
	"03023": "Ceccano",
	"03024": "Ceprano",
	"06040": "Vallo di Nera",
	"03044": "Cervaro",
	"00052": "Cerveteri",
	"00043": "Ciampino",
	"04012": "Cisterna di Latina",
	"06010": "Monte Santa Maria Tiberina",
	"06062": "Città della Pieve",
	"06018": "Città di Castello",
	"02015": "Cittaducale",
	"01033": "Civita Castellana",
	"00053": "Civitavecchia",
	"02022": "Collalto Sabino",
	"06050": "Collazzone",
	"00034": "Colleferro",
	"02042": "Collevecchio",
	"09020": "Villanovafranca",
	"02043": "Contigliano",
	"06073": "Corciano",
	"06021": "Costacciaro",
	"09073": "Cuglieri",
	"09033": "Decimomannu",
	"06053": "Deruta",
	"08032": "Desulo",
	"09041": "Dolianova",
	"09015": "Domusnovas",
	"08022": "Dorgali",
	"09067": "Elmas",
	"09051": "Escalaplano",
	"09052": "Escolca",
	"03045": "Esperia",
	"09053": "Esterzili",
	"01034": "Fabrica di Roma",
	"05015": "Fabro",
	"02032": "Fara in Sabina",
	"05034": "Ferentillo",
	"03013": "Ferentino",
	"02023": "Fiamignano",
	"00065": "Fiano Romano",
	"05016": "Ficulle",
	"03014": "Fiuggi",
	"00054": "Fiumicino",
	"06034": "Foligno",
	"04022": "Fondi",
	"08023": "Fonni",
	"03035": "Fontana Liri",
	"00013": "Mentana",
	"02044": "Forano",
	"09083": "Fordongianus",
	"04023": "Formia",
	"06022": "Fossato di Vico",
	"00044": "Frascati",
	"06054": "Fratta Todina",
	"03100": "Frosinone",
	"04024": "Gaeta",
	"01035": "Gallese",
	"08020": "Torpè",
	"09054": "Genoni",
	"00045": "Genzano di Roma",
	"00025": "Gerano",
	"09055": "Gergei",
	"09074": "Ghilarza",
	"06030": "Valtopina",
	"05024": "Giove",
	"09035": "Gonnosfanadiga",
	"09093": "Gonnostramatza",
	"00046": "Grottaferrata",
	"01025": "Grotte di Castro",
	"06035": "Gualdo Cattaneo",
	"06023": "Gualdo Tadino",
	"03016": "Guarcino",
	"05025": "Guardea",
	"06020": "Gubbio",
	"00012": "Guidonia Montecelio",
	"09036": "Guspini",
	"09016": "Iglesias",
	"09056": "Isili",
	"03036": "Isola del Liri",
	"07044": "Ittiri",
	"08044": "Jerzu",
	"00055": "Ladispoli",
	"08045": "Lanusei",
	"04025": "Lenola",
	"02016": "Leonessa",
	"00026": "Licenza",
	"06060": "Paciano",
	"09022": "Lunamatrona",
	"07025": "Luras",
	"08015": "Macomer",
	"06063": "Magione",
	"02046": "Magliano Sabina",
	"08024": "Mamoiada",
	"00066": "Manziana",
	"00047": "Marino",
	"09094": "Marrubiu",
	"06055": "Marsciano",
	"06056": "Massa Martana",
	"04026": "Minturno",
	"09095": "Pompu",
	"09023": "Monastir",
	"09042": "Monserrato",
	"01014": "Montalto di Castro",
	"06057": "Monte Castello di Vibio",
	"00077": "Monte Compatri",
	"00078": "Monte Porzio Catone",
	"03025": "Monte San Giovanni Campano",
	"05026": "Montecastrilli",
	"06036": "Montefalco",
	"01027": "Montefiascone",
	"05030": "Polino",
	"05010": "San Venanzo",
	"05017": "Monteleone d'Orvieto",
	"06045": "Monteleone di Spoleto",
	"02033": "Monteleone Sabino",
	"00015": "Monterotondo",
	"06014": "Montone",
	"02034": "Montopoli di Sabina",
	"07013": "Mores",
	"00067": "Morlupo",
	"03017": "Morolo",
	"09043": "Muravera",
	"05035": "Narni",
	"01036": "Nepi",
	"00017": "Nerola",
	"00048": "Nettuno",
	"06025": "Nocera Umbra",
	"06046": "Norcia",
	"07032": "Nulvi",
	"08100": "Nuoro",
	"09057": "Nuragus",
	"09058": "Nurallao",
	"09024": "Nuraminis",
	"09059": "Nurri",
	"07026": "Olbia",
	"00035": "Olevano Romano",
	"08025": "Oliena",
	"09084": "Villanova Truschedu",
	"08026": "Orani",
	"08027": "Orgosolo",
	"09170": "Oristano",
	"08028": "Orosei",
	"09061": "Orroli",
	"01028": "Orte",
	"08036": "Ortueri",
	"05018": "Orvieto",
	"02035": "Orvinio",
	"07027": "Oschiri",
	"07033": "Osilo",
	"07045": "Ossi",
	"07014": "Ozieri",
	"09030": "Sardara",
	"07015": "Padria",
	"00036": "Palestrina",
	"03018": "Paliano",
	"00018": "Palombara Sabina",
	"06064": "Panicale",
	"06065": "Passignano sul Trasimeno",
	"07016": "Pattada",
	"05028": "Penna in Teverina",
	"08046": "Perdasdefogu",
	"07034": "Perfugas",
	"06121": "Perugia",
	"02024": "Pescorocchiano",
	"02025": "Petrella Salto",
	"06066": "Piegaro",
	"06026": "Pietralunga",
	"07017": "Ploaghe",
	"03026": "Pofi",
	"02018": "Poggio Bustone",
	"02047": "Poggio Mirteto",
	"02037": "Poggio Moiano",
	"00071": "Pomezia",
	"03037": "Pontecorvo",
	"04014": "Pontinia",
	"04027": "Ponza",
	"07046": "Porto Torres",
	"02019": "Posta",
	"07018": "Pozzomaggiore",
	"06047": "Preci",
	"04015": "Priverno",
	"09050": "Villa San Pietro",
	"09045": "Quartu Sant'Elena",
	"09044": "Quartucciu",
	"02100": "Rieti",
	"00068": "Rignano Flaminio",
	"03027": "Ripi",
	"02026": "Rocca Sinibalda",
	"03038": "Roccasecca",
	"00186": "Roma",
	"01037": "Ronciglione",
	"00027": "Roviano",
	"09085": "Ruinas",
	"04016": "Sabaudia",
	"09062": "Sadali",
	"09086": "Samugheo",
	"03046": "San Donato Val di Comino",
	"04017": "San Felice Circeo",
	"09037": "San Gavino Monreale",
	"05029": "San Gemini",
	"03047": "San Giorgio a Liri",
	"03028": "San Giovanni Incarico",
	"06016": "San Giustino",
	"09097": "San Nicolò d'Arcidano",
	"09026": "San Sperate",
	"07052": "San Teodoro",
	"09025": "Sanluri",
	"09017": "Sant'Antioco",
	"03048": "Sant'Apollinare",
	"03049": "Sant'Elia Fiumerapido",
	"09096": "Santa Giusta",
	"00058": "Santa Marinella",
	"07028": "Santa Teresa Gallura",
	"09075": "Santu Lussurgiu",
	"09018": "Sarroch",
	"02038": "Scandriglia",
	"09078": "Sennariolo",
	"06027": "Scheggia e Pascelupo",
	"09076": "Sedilo",
	"07035": "Sedini",
	"00037": "Segni",
	"09047": "Selargius",
	"07036": "Sennori",
	"04013": "Sermoneta",
	"09038": "Serramanna",
	"09027": "Serrenti",
	"09063": "Serri",
	"09028": "Sestu",
	"09060": "Settimo San Pietro",
	"09029": "Tuili",
	"09064": "Seui",
	"09065": "Seulo",
	"06028": "Sigillo",
	"08017": "Silanus",
	"09088": "Simaxis",
	"08018": "Sindia",
	"08029": "Siniscola",
	"09048": "Sinnai",
	"09077": "Solarussa",
	"03039": "Sora",
	"08038": "Sorgono",
	"01038": "Soriano nel Cimino",
	"07037": "Sorso",
	"06038": "Spello",
	"04029": "Sperlonga",
	"06049": "Spoleto",
	"02048": "Stimigliano",
	"05039": "Stroncone",
	"00028": "Subiaco",
	"03019": "Supino",
	"01015": "Sutri",
	"01016": "Tarquinia",
	"07029": "Tempio Pausania",
	"05100": "Terni",
	"04019": "Terracina",
	"09098": "Terralba",
	"08047": "Tertenia",
	"09019": "Teulada",
	"07047": "Thiesi",
	"06059": "Todi",
	"02039": "Toffia",
	"00059": "Tolfa",
	"08039": "Tonara",
	"06089": "Torgiano",
	"07048": "Torralba",
	"02049": "Torri in Sabina",
	"08048": "Tortolì",
	"09079": "Tresnuraghes",
	"06039": "Trevi",
	"00069": "Trevignano Romano",
	"07038": "Trinità d'Agultu e Vignola",
	"06069": "Tuoro sul Trasimeno",
	"01017": "Tuscania",
	"06019": "Umbertide",
	"09099": "Uras",
	"07049": "Usini",
	"01018": "Valentano",
	"06029": "Valfabbrica",
	"07039": "Valledoria",
	"00038": "Valmontone",
	"00049": "Velletri",
	"03029": "Veroli",
	"01019": "Vetralla",
	"00029": "Vicovaro",
	"01039": "Vignanello",
	"09039": "Villacidro",
	"08049": "Villagrande Strisaili",
	"07019": "Villanova Monteleone",
	"09066": "Villanova Tulo",
	"09049": "Villasimius",
	"09034": "Villasor",
	"01100": "Viterbo",
	"00039": "Zagarolo",
	"00100": "Roma",
	"0010": "Roma",
	"10100": "Torino",
	"1010": "Torino",
	"20100": "Milano",
	"2010": "Milano",
	"80100": "Napoli",
	"8010": "Napoli",
	"90100": "Palermo",
	"9010": "Palermo",
	"16100": "Genova",
	"1610": "Genova",
	"40100": "Bologna",
	"4010": "Bologna",
	"5010": "Firenze",
	"70100": "Bari",
	"7010": "Bari",
	"95100": "Catania",
	"9510": "Catania",
	"30100": "Venezia",
	"3010": "Venezia",
	"3710": "Verona",
	"98100": "Messina",
	"9810": "Messina",
	"35100": "Padova",
	"3510": "Padova",
	"34100": "Trieste",
	"3410": "Trieste"
}

export const translateCap = (q) => {
	if (capList.hasOwnProperty(q)) {
		let locationString = capList[q] + ", Italia";
		q = locationString;
	}
	return q;
}


// WEBPACK FOOTER //
// ./src/modules/location.js